export const EnglishLanguageContent = {
  flowComplete: "You have already Completed the process",
  disagree_page: {
    disagree_title: "Please choose the reason(s) for your disagreement",
    remarks: "Remarks",
    please_enter_remarks: "Please enter the remarks",
    personal_title: "Personal Details Disagree",
    policy_title: "Policy Details Disagree",
    reason:
      "Please select the reason of disagreement and enter the details in the textbox.",
  },
  error_page: {
    sorry: "Sorry ",
    something_went_wrong: "Something went wrong.",
  },
  hdfc_disclaimer_page: {
    title: "Bot Voice Over",
    rbb: {
      ulip_points: [
        {
          type: "embeddedHtml",
          content:
            "You can refer to the policy document to know about all the terms and conditions of the product and approach the Insurer or the Bank during the available free-look period of 30 days in case of any issue.",
        },
        {
          type: "embeddedHtml",
          content:
            "No promises were made by sales person to you for any other banking products or services while buying this insurance policy.  This is not a fixed deposit or a mutual fund or a single premium policy. You give consent to Aditya Birla Sun Life Insurance to use your personal & financial information available in HDFC bank records for processing the application.",
        },
        {
          type: "embeddedHtml",
          content:
            "With regard to your policy, you have read and understood the key policy features while filling the proposal form.",
        },
      ],
      non_par_points: [
        {
          type: "embeddedHtml",
          content:
            "You can refer to the policy document to know about all the terms and conditions of the product and approach the Insurer or the Bank during the available free-look period of 30 days in case of any issue.",
        },
        {
          type: "interpolated",
          content:""

        },
       

        {
          type: "embeddedHtml",
          content:
            "No promises were made by sales person to you for any other banking products or services while buying this insurance policy. This is not a fixed deposit or a single premium policy. You give consent to Aditya Birla Sun Life Insurance to use your personal & Financial information available in HDFC bank records for processing the application.",
        },
        {
          type: "embeddedHtml",
          content:
            "With regard to your policy, you have read and understood the key policy features while filling the proposal form.",
        },
      ],
      par_points: [
        {
          type: "embeddedHtml",
          content:
            "You can refer to the policy document to know about all the terms and conditions of the product and approach the Insurer or the Bank during the available free-look period of 30 days in case of any issue.",
        },
        {
          type: "interpolated",
          content:""

        },

        {
          type: "embeddedHtml",
          content:
            "No promises were made by sales person to you for any other banking products or services while buying this insurance policy. This is not a fixed deposit or a single premium policy. You give consent to Aditya Birla Sun Life Insurance to use your personal & Financial information available in HDFC bank records for processing the application.",
        },
        {
          type: "embeddedHtml",
          content:
            "With regard to your policy, you have read and understood the key policy features while filling the proposal form.",
        },
      ],
    },
    vrm: {
      ulip_points: [
        {
          type: "embeddedHtml",
          content:
            "You can refer to the policy document & benefits illustration to know about all the terms and conditions of the product and approach the Insurer or Bank during the free-look period of 30 days in case of any issue.",
        },
        {
          type: "embeddedHtml",
          content:
            "Please continue making the premium payment for the entire term. Any pre-mature stoppage of premium or surrender would lead to loss in principal amount as well as policy benefits.",
        },
        {
          type: "embeddedHtml",
          content:
            "No promises were made by sales person to you for any other banking products or services while buying this insurance policy. This is not a fixed deposit or a mutual fund or a single premium policy. You give consent to Aditya Birla Sun Life Insurance to use your personal & Financial information available in HDFC bank records for processing the application.",
        },
        {
          type: "embeddedHtml",
          content:
            "With regard to your policy, you have read and understood the key policy features while filling the proposal form.",
        },
      ],

      non_par_points: [
        {
          type: "embeddedHtml",
          content:
            "Please  continue making the premium payment for the entire term. Any pre-mature stoppage of premium or surrender would lead to loss in principal amount as well as policy benefits.",
        },
        {
          type: "embeddedHtml",
          content: "You will receive policy benefits as per benefit illustration shared."
        },
        
        

        {
          type: "embeddedHtml",
          content:
            "No promises were made by sales person to you for any other banking products or services while buying this insurance policy. This is not a fixed deposit or a single premium policy. You give consent to Aditya Birla Sun Life Insurance to use your personal & Financial information available in HDFC bank records for processing the application.",
        },
        {
          type: "embeddedHtml",
          content:
            "With regard to your policy, you have read and understood the key policy features while filling the proposal form.",
        },
      ],
      par_points: [
        {
          type: "embeddedHtml",
          content:
            "Please  continue making the premium payment for the entire term. Any pre-mature stoppage of premium or surrender would lead to loss in principal amount as well as policy benefits.",
        },
        {
          type: "embeddedHtml",
          content: "You will receive policy benefits as per benefit illustration shared."
        },
        {
          type: "embeddedHtml",
          content:
            "No promises were made by sales person to you for any other banking products or services while buying this insurance policy. This is not a fixed deposit or a single premium policy. You give consent to Aditya Birla Sun Life Insurance to use your personal & Financial information available in HDFC bank records for processing the application.",
        },
        {
          type: "embeddedHtml",
          content:
            "With regard to your policy, you have read and understood the key policy features while filling the proposal form.",
        },
      ],
    },
  },
  information_page: {
    info_title: "Important points to remember",
    common_points_start: [
      {
        type: "text",
        content:
          "Kindly read the important information displayed on the screen.",
      },
      // { type: 'embeddedHtml', content: "We will Dispatch your policy document with-in 7 working days from the policy issuance date. If you have opted for an e-policy, you will receive the dematerialised policy document in your e-insurance account. Aditya Birla Sun Life provides you with an online service known as My Insurance which helps you avail facilities like contact detail updation, premium payments, check fund value details etc. Kindly log onto our website <a href='www.adityabirlasunlifeinsurance.com'>www.adityabirlasunlifeinsurance.com</a> to register yourself. For detailed information, kindly go through the policy document .You can also call our toll free customer service number <a href='tel:18002707000' style={{ textDecoration: 'none' }}> 1800 270 7000 </a>" },
      {
        type: "text",
        content:
          "Life insurance is a standalone product and is neither a fixed deposit nor loan nor is it linked to any other banking products. Other than the policy benefits as specifically mentioned under the policy contract, there are no additional benefits under the policy. ",
      },
    ],
    ulip_points: [
      { type: 'text', content: "ABSLI (ULIP) being purchased by you, is NOT eligible for exemption under tax at the time of payout or policy proceeds under section 10(10 D) as per the new tax norms issued under the Finance Budget 2021. As per the Finance Budget 2021, all Unit Linked Insurance policies newly purchased on or after 1st Feb 2021 with an aggregate premium exceeding Rs.2,50,000/- for a given financial year , shall NOT be eligible for tax exemption under section 10 (10 D) at the time of payout (except death claim)."},
      { type: 'text', content: 'Being an unit linked plan, withdrawals are allowed post completion of 5 years, we however would advice you to continue paying the premium for the entire term of the product in absence of same your fund value will get impacted due to charges applicable.'},
      { type: 'text', content: "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy."},
      {type: 'text', content: "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer"},
      { type: 'checkbox', content: "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy." },
      ],
    hdfc_ulip_points: [
      {
        type: "text",
        content:
          "We would like to inform you that as per the Finance Act 2021, all Unit Linked Insurance Policies purchased on or after 1st Feb 2021 with an aggregate premium exceeding INR 2,50,000 for any given financial year during the term of the policy, shall NOT be eligible for tax exemption under section 10(10D) of the Income-Tax Act, 1961 at the time of payout (except death claim).",
      },
      {
        type: "text",
        content:
          "Being an unit linked plan, withdrawals are allowed post completion of 5 years, we however would advice you to continue paying the premium for the entire term of the product in absence of same your fund value will get impacted due to charges applicable.",
      },
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy. Please note that surrendering the policy before the completion of the policy term and premium paying term will lead to significantly lower pay out than the illustrated maturity value. For additional details kindly refer the Benefit illustration. In case of non- payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the pre-existing policy details availed by me in the past on the application form while applying for this policy.We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document or 30 days from the date of credit of your policy to e-Insurance Account.We will Dispatch your policy document with-in 7 working days from the policy issuance date. If you have opted for an e-policy, you will receive the dematerialised policy document in your e-insurance account. Aditya Birla Sun Life provides you with an online service known as My Insurance which helps you avail facilities like contact detail updation, premium payments, check fund value details etc. Kindly log onto our website www.adityabirlacapital.com to register yourself. For detailed information, kindly go through the policy document .You can also call our toll free customer service number 18002707000.I hereby confirm that, I have read and Confirmed/signed the Life Insurance Suitability Profiler i.e., the One Page verification form with investment risk profile mentioned in it while filling the proposal form",
      },
    ],
    hdfc_par_and_non_par_points: [
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy. We would like to inform you that except for guaranteed moneybacks/income , other pay out like bonus , maturity benefit or surrender benefit are not 100% guaranteed and is a combination of both guaranteed and non-guaranteed elements. We request you to refer the benefit illustration and policy document for more details on the this. Please note that surrendering the policy before the completion of the policy term and premium paying term i.e pre- mature surrenders like surrendering the policy before or after the start of the payout will lead to significantly lower payout than the illustrated maturity value For additional details kindly refer the Benefit illustration with respect to understanding lock-in period as applicable & surrender value payable before and after the start of the payout. In case of non- payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.",
      },
      {
        type: "text",
        content: "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure Risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer.",
      },
      {
        type: "text",
        content: 'I hereby confirm that, I have declared all the pre-existing policy details availed by me in the past on the application form while applying for this policy.',
      },
      {
        type: "text",
        content: "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document or 30 days from the date of credit of your policy to e-Insurance Account.",
      },
      {
        type: "text",
        content: "We will Dispatch your policy document with-in 7 working days from the policy issuance date. If you have opted for an e-policy, you will receive the dematerialised policy document in your e-insurance account. Aditya Birla Sun Life provides you with an online service known as My Insurance which helps you avail facilities like contact detail updation, premium payments, check fund value details etc. Kindly log onto our website www.adityabirlacapital.com to register yourself. For detailed information, kindly go through the policy document .You can also call our toll free customer service number 18002707000.",
      },
      {
        type: "checkbox",
        content: "I hereby confirm that, I have read and Confirmed/signed the Life Insurance Suitability Profiler i.e., the One Page verification form with investment risk profile mentioned in it while filling the proposal form.",
      },
    ],
    par_and_non_par_points: [
      {type: 'text', content: 'We request you to continue paying the premium for the entire term to enjoy the benefits of the policy. We would like to inform you that except for guaranteed moneybacks/income , other pay out like bonus , maturity benefit or surrender benefit are not 100% guaranteed and is a combination of both guaranteed and non-guaranteed elements. We request you to refer the benefit illustration and policy document for more details on the this.'},
      {type: 'text', content: "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer"},
      {type: 'text', content: 'Please note that surrendering the policy before the completion of the policy term and premium paying term i.e pre- mature surrenders like surrendering the policy before or after the start of the payout will lead to significantly lower payout than the illustrated maturity value" For additional details kindly refer the Benefit illustration". with respect to understanding lock-in period as applicable & surrender value payable before and after the start of the payout. In case of non-payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.'},
      { type: 'text', content: "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document 30 days from the date of credit of your policy to e-Insurance Account."},
      { type: 'checkbox', content: "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy." }    ,
     ], 
    // common_points_end: [
    //   {
    //     type: "text",
    //     content:
    //       "Please note that surrendering the policy before the completion of the policy term and premium paying term will lead to significantly lower pay out than the illustrated maturity value. For additional details kindly refer the Benefit illustration. In case of non-payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.",
    //   },
    //   {
    //     type: "text",
    //     content:
    //       "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document 30 days from the date of credit of your policy to e-Insurance Account.",
    //   },
    // ],
  },
  landing_page: {
    start: "Start",
    hi: "Hi ",
    heading_1a: "Welcome to Aditya Birla Sun Life Insurance Family ",
    heading_1b: "Your application number is ",
  },
  personal_detail_page: {
    personal_title: "Personal Details",
    application_number: "Application Number",
    policy_number: "Policy Owner",
    owner_DOB: "Owner DOB",
    life_insured: "Life Insured",
    insured_DOB: "Insured DOB",
    nominee_name: "Nominee Name",
    income: "Owner Income",
    occupation: "Owner Occupation",
    email: "Email ID",
    contact_number: "Contact Number",
    address: "Address",
    city_state: "City/State",
    pinCode: "Pincode",
    hdfcCheckBox:
      "I hereby consent to HDFC Bank to share my personal information like phone number, e-mail ID, address, Non-Cash Credit, profile, etc. with the insurance company in order to facilitate faster processing of my insurance proposal. I hereby confirm No promise was made by the sales representative for any other banking product /service while buying this insurance.",
    info: 'If all information displayed on the screen is correct, Please click on "Agree" else click "Disagree"',
  },
  photo_proof_page: {
    confirmation: "Confirmation",
    subTitle_1a: "You confirm that the ",
    subTitle_1b: " Details given in the previous page are correct.",
    subTitle_2: "Please click on the Capture button to capture photo.",
    personal: "Personal",
    policy: "Policy",
  },
  policy_detail_page: {
    policy_title: "Policy Details",
    plan_name: "Plan Name",
    payment: "Payment Frequency",
    policy_term: "Policy Term",
    years: " years",
    premium_payment: "Premium Payment Term",
    premium_amount: "Premium Amount",
    sum_assured: "Sum Assured",
    purpose_of_insurance: "Purpose of Insurance",
    application_no: "Application Number",
    plan_type: "Plan Type",
    info: 'If all information displayed on the screen is correct, Please click on "Agree" else click "Disagree"',
  },
  thank_you_page: {
    thank_you_title: "Thank You",
    message1:
      "for your valuable time, your sales representative will get in touch with you shortly",
    message2:
      "for your valuable time. We appreciate your decision for choosing Aditya Birla Sun Life Insurance as your preferred life insurer.",
    message3: "Your application number is ",
  },
  verification_page: {
    verification_title: "Verification",
    verification_sub_title: "Please enter the below details",
    verify_dob: "Date of Birth of the life insured",
    verify_phone: "Phone Number of the proposer",
    language: "Language",
    otp_title: "Enter the OTP sent on your number",
    otp_placeHolder: "OTP",
    seconds_left: " seconds left..",
    errorMsg1: "you have exceeded all the attempts. Please call back on ",
    errorMsg2: "Something went wrong,Please try again.",
    errorMsg12: " and enter the correct details.",
    incorrectMsg: "Incorrect OTP. Please try again.",
    sendOtpAgain: "OTP has been sent again.",
    wrongDate: "The Date of Birth entered is incorrect. Please try again.",
    wrongPhone: "The Phone entered is incorrect. Please try again.",
    wrongLanguage: "The language selected is incorrect. Please try again.",
    otp_disclaimer: "OTP will be sent on the registered mobile number",
  },
  video_proof_page: {
    video_title: "Customer Consent Video Undertaking",
    detail_1: "Please Click on record button and read out the below Text",
    detail_2_a: "I ",
    detail_2_b: ", hereby confirm that I have understood the details of",
    detail_3:
      " and agree to terms and conditions explained to me. I hereby agree to process my application. My mobile number is ",
    recordFailure:
      "Sorry, the video wasn't uploaded successfully. Please click on the submit button to upload again.",
    permissionMsg: "Video Permission denied, please give permission for video",
    record_again: "Please record again",
  },
  photo_dialog_page: { confirm_title: "Confirm the picture taken" },
  buttons: {
    initiate_recorder: "Initiate Recorder",
    retake: "Retake",
    confirm: "Confirm",
    stop: "Stop",
    next: "Next",
    back: "Back",
    submit: "Submit",
    resend: "Resend",
    agree: "Agree",
    disagree: "Disagree",
    capture: "Capture",
    record: "Record",
    re_record: "Re-record",
    verify: "Verify",
    replay: "Replay"
  },
};

export const HindiLanguageContent = {
  flowComplete: "आप अपना प्रोसेस पूरा कर चुके हैं ",
  disagree_page: {
    disagree_title: "कृपया अपनी असहमति का कारण चुनें",
    remarks: "रिमार्क",
    please_enter_remarks: "कृपया रिमार्क दर्ज करें",
    personal_title: "व्यक्तिगत विवरण असहमत",
    policy_title: "पॉलिसी विवरण असहमत",
    reason: "कृपया असहमति का कारण चुनें और टेक्स्टबॉक्स में विवरण दर्ज करें।",
  },
  error_page: {
    sorry: "माफ़ करना ",
    something_went_wrong: "कुछ गलत हो गया.",
  },
  hdfc_disclaimer_page: {
    title: "बॉट वौइस् ओवर",
    rbb: {
      ulip_points: [
        {
          type: "embeddedHtml",
          content:
            "खरीदते समय बिक्री व्यक्ति द्वारा आपसे किसी अन्य बैंकिंग उत्पाद या सेवा के लिए कोई वादा नहीं किया गया था। यह बीमा पॉलिसी है। यह कोई फिक्स्ड डिपॉजिट या म्यूचुअल फंड या सिंगल प्रीमियम पॉलिसी नहीं है। आप एचडीएफसी लाइफ को आवेदन की प्रक्रिया के लिए एचडीएफसी बैंक रिकॉर्ड में उपलब्ध आपकी व्यक्तिगत और वित्तीय जानकारी का उपयोग करने की सहमति देते हैं।",
        },
        {
          type: "embeddedHtml",
          content:
            "अपनी पॉलिसी के संबंध में, आपने प्रस्ताव फॉर्म भरते समय पॉलिसी की मुख्य विशेषताओं को पढ़ा और समझा है।",
        },
      ],
      non_par_points: [
        {
          type: "embeddedHtml",
          content:
            "आपको पालिसी लाभ वही मिलेंगे जो लाभ विवरण में साझा किये गए है ",
        },
        {
          type: "embeddedHtml",
          content:"बिक्री व्यक्ति द्वारा किसी अन्य बैंकिंग उत्पाद के लिए आपसे कोई वादा नहीं किया गया था इस बीमा पॉलिसी को खरीदते समय आपको किसी भी प्रकार की बीमा पॉलिसी या सेवाओं का भुगतान नहीं करना होगा। यह कोई फिक्स्ड डिपॉजिट या सिंगल प्रीमियम पॉलिसी नहीं है। आप एचडीएफसी लाइफ को आवेदन की प्रक्रिया के लिए एचडीएफसी बैंक रिकॉर्ड में उपलब्ध आपकी व्यक्तिगत और वित्तीय जानकारी का उपयोग करने की सहमति देते हैं। अपनी पॉलिसी के संबंध में, आपने प्रस्ताव फॉर्म भरते समय पॉलिसी की मुख्य विशेषताओं को पढ़ा और समझा है।"

        },
       
      ],
      par_points: [
        {
          type: "embeddedHtml",
          content:
            "आपको पालिसी लाभ वही मिलेंगे जो लाभ विवरण में साझा किये गए है ",
        },
        {
          type: "embeddedHtml",
          content:"यह इंश्योरेंस खरीदते समय किसी भी अन्य बैंकिंग उत्पाद/ सेवा के लिए सेल्स प्रतिनिधि द्वारा कोई वादा नहीं किया गया था. यह कोई सावधि जमा या एकल प्रीमियम पॉलिसी नहीं है आप एचडीएफसी लाइफ को आवेदन की प्रक्रिया के लिए एचडीएफसी बैंक रिकॉर्ड में उपलब्ध आपकी व्यक्तिगत और वित्तीय जानकारी का उपयोग करने की सहमति देते हैं।"

        },

        {
          type: "embeddedHtml",
          content:
            "अपनी पॉलिसी के संबंध में, आपने प्रस्ताव फॉर्म भरते समय पॉलिसी की मुख्य विशेषताओं को पढ़ा और समझा है।",
        },
        
      ],
    },
    vrm: {
      ulip_points: [
        {
          type: "embeddedHtml",
          content:
            "कृपया पूरी अवधि के लिए प्रीमियम का भुगतान करना जारी रखें। प्रीमियम के किसी भी समय से पहले रोक या सरेंडर से मूल राशि के साथ-साथ पॉलिसी लाभों में भी कमी आएगी।",
        },
        {
          type: "embeddedHtml",
          content:
            "इस बीमा पॉलिसी को खरीदते समय बिक्री व्यक्ति द्वारा आपसे किसी अन्य बैंकिंग उत्पाद या सेवा के लिए कोई वादा नहीं किया गया था। यह कोई सावधि जमा या म्यूचुअल फंड या एकल प्रीमियम पॉलिसी नहीं है। आप एचडीएफसी लाइफ को आवेदन की प्रक्रिया के लिए एचडीएफसी बैंक रिकॉर्ड में उपलब्ध आपकी व्यक्तिगत और वित्तीय जानकारी का उपयोग करने की सहमति देते हैं।",
        },
        {
          type: "embeddedHtml",
          content:
            "अपनी पॉलिसी के संबंध में, आपने प्रस्ताव फॉर्म भरते समय पॉलिसी की मुख्य विशेषताओं को पढ़ा और समझा है।",
        },
      ],

      non_par_points: [
        {
          type: "embeddedHtml",
          content: "कृपया पूरी अवधि के लिए प्रीमियम का भुगतान करना जारी रखें। प्रीमियम के किसी भी समय से पहले रोक या सरेंडर से मूल राशि के साथ-साथ पॉलिसी लाभों में भी कमी आएगी।",
        },
        {
          type: "embeddedHtml",
          content:  "आपको पालिसी लाभ वही मिलेंगे जो लाभ विवरण में साझा किये गए है ",
        },

        {
          type: "embeddedHtml",
          content:
            "इस बीमा पॉलिसी को खरीदते समय बिक्री व्यक्ति द्वारा आपसे किसी अन्य बैंकिंग उत्पाद या सेवा के लिए कोई वादा नहीं किया गया था। यह कोई सावधि जमा या एकल प्रीमियम पॉलिसी नहीं है। आप आवेदन प्रक्रिया के लिए एचडीएफसी लाइफ को एचडीएफसी बैंक रिकॉर्ड में उपलब्ध आपकी व्यक्तिगत और वित्तीय जानकारी का उपयोग करने की सहमति देते हैं। अपनी पॉलिसी के संबंध में, आपने प्रस्ताव फॉर्म भरते समय पॉलिसी की मुख्य विशेषताओं को पढ़ा और समझा है।",
        },
        
      ],
      par_points: [
        {
          type: "embeddedHtml",
          content:
            "कृपया पूरी अवधि के लिए प्रीमियम का भुगतान करना जारी रखें। प्रीमियम के किसी भी समय से पहले रोक या सरेंडर से मूल राशि के साथ-साथ पॉलिसी लाभों में भी कमी आएगी।",
        },

        {
          type: "embeddedHtml",
          content:
            "आपको पालिसी लाभ वही मिलेंगे जो लाभ विवरण में साझा किये गए है ",
        },
        {
          type: "embeddedHtml",
          content:
            "इस बीमा पॉलिसी को खरीदते समय बिक्री व्यक्ति द्वारा आपसे किसी अन्य बैंकिंग उत्पाद या सेवा के लिए कोई वादा नहीं किया गया था। यह कोई सावधि जमा या एकल प्रीमियम पॉलिसी नहीं है। आप एचडीएफसी लाइफ को आवेदन की प्रक्रिया के लिए एचडीएफसी बैंक रिकॉर्ड में उपलब्ध आपकी व्यक्तिगत और वित्तीय जानकारी का उपयोग करने की सहमति देते हैं।",
        },
        {
          type: "embeddedHtml",
          content: 'अपनी पॉलिसी के संबंध में, आपने प्रस्ताव फॉर्म भरते समय पॉलिसी की मुख्य विशेषताओं को पढ़ा और समझा है।'
        }
      ],
    },
  },

  information_page: {
    info_title: "याद रखने योग्य महत्वपूर्ण पॉइंट्स",
    common_points_start: [
      {
        type: "text",
        content: "कृपया स्क्रीन पर प्रदर्शित महत्वपूर्ण जानकारी पढ़ें.",
      },
      {
        type: "text",
        content:
          "लाइफ इंश्योरेंस एक अलग उत्पाद है और यह न तो फिक्स्ड डिपॉजिट है न ही लोन है न ही किसी अन्य बैंकिंग उत्पाद से जुड़ा है. पॉलिसी कॉन्ट्रैक्ट के अंतर्गत पॉलिसी के फायदों के अलावा पॉलिसी में कोई अतिरिक्त लाभ नहीं है.",
      },
    ],
    hdfc_ulip_points: [
      {
        type: "text",
        content:
          "आप द्वारा खरीदा गया एबीएसएलआई (यूलिप) फायनांस बजट 2021 के तहत जारी नए कर मानकों के अनुसार धारा 10(10 डी) के अंतर्गत भुगतान के समय या पॉलिसी की धनराशि कर से छूट के लिए पात्र नहीं है. फायनांस बजट 2021 के अनुसार, 1 फरवरी 2021 को या बाद में नई खरीदी गई सभी यूनिट लिंक्ड इंश्योरेंस पॉलिसियॉं जिनकी किसी दिए गए वित्त वर्ष के लिए रु.2,50,000 से अधिक की कुल प्रीमियम राशि भुगतेन के समय धारा 10(10डी) के तहत कर रियायत के लिए पात्र नहीं होगी (मृत्यु दावा छोड़कर).यूनिट लिंक्ड प्लान होने के नाते, 5 वर्ष पूर्ण होने के बाद निकासियों की अनुमति होती है, लेकिन हम आपको उत्पाद की संपूर्ण अवधि के लिए प्रीमियम का भुगतान जारी रखने की सलाह देंगे जिसकी अनुपस्थिति में आपका फंड मूल्य लागू शुल्कों के कारण प्रभावित होगा.",
      },
      
      {
        type: "text",
        content:
          "पॉलिसी के फायदों का आनंद लेने के लिए पूरी अवधि तक प्रीमियम का भुगतान जारी रखने का हम आपसे निवेदन करते हैं. कृपया ध्यान रहे कि पॉलिसी अवधि और प्रीमियम भुगतान अवधि की पूर्णता से पहले पॉलिसी समर्पित करने से उदाहरण में दिए गए परिपक्वता मूल्य की तुलना में उल्लेखनीय रूप से कमतर भुगतान होगा. अतिरिक्त विवरणों के लिए कृपया लाभ का उदाहरण देखें. प्राथमिक पॉलिसी के प्रति प्रीमियमों का भुगतान नहीं किए जाने के मामले में, राइडर लाभ भी समाप्त हो जाएगा.",
      },
      
      {
        type: "checkbox",
        content:
          "मैं एतद्द्वारा पुष्टि करता हूँ कि मैने पहले अपने द्वारा ली गई सभी पूर्व विद्यमान पॉलिसियों के विवरणों की घोषणा इस पॉलिसी के लिए आवेदन करते समय आवेदन पत्र में कर दी है.हम पॉलिसी कन्वर्ज़न के लिए आगे बढ़ेंगे जो किसी भी बकाया आवश्यकताओं को पूरा करने के अधीन है. यदि आप पॉलिसी की शर्तों के साथ संतुष्ट नहीं हैं या कोई बदलाव चाहते हैं तो आपके पास फ्री लुक अवधि के अंदर हमसे वापस संपर्क करने का विकल्प है, जहॉं आपकी पॉलिसी में फ्रीलुक अवधि आपके कागजी पॉलिसी दस्तावेज की प्राप्ति से 15 दिन है, जब कि ई-इंश्योरेंस अकाउंट में आपकी पॉलिसी जमा होने के दिनांक से 30 दिन है.हम पॉलिसी जारी करने के दिनांक से 7 कार्य दिवसों के अंदर आपको पॉलिसी दस्तावेज भेज देंगे. यदि आपने ई-पॉलिसी का चयन किया है तो आपको अपने ई-इंश्योरेंस अकाउंट में डिमटीरियलाइज़्ड पॉलिसी दस्तावेज मिल जाएगा. आदित्य बिरला सन लाइफ आपको माय इंश्योरेंस के रूप में जानी जानेवाली ऑनलाइन सेवा प्रदान करती है जो संपर्क विवरण अपडेशन (अद्यतनीकरण), प्रीमियम भुगतान, फंड मूल्य विवरण जांचने जैसी सुविधाएँ हासिल करने में मदद करता है. अपना रजिस्ट्रेशन करने के लिए कृपया हमारी वेबसाइट www.adityabirlacapital.com पर लॉग ऑन करें. विस्तृत जानकारी के लिए, कृपया पॉलिसी दस्तावेज पढ़ें. आप हमारे टोल फ्री कस्टमर सर्विस नंबर 18002707000 पर भी कॉल कर सकते हैं.मै एतद्द्वारा पुष्टि करता हूँ कि मैने प्रस्ताव फॉर्म भरते समय लाइफ इंश्योरेंस सूटेबिलिटी प्रोफाइलर यानी उसमें वर्णित वन पेज वैरिफिकेशन फॉर्म के साथ इनवेस्टमेंट रिस्क प्रोफाइल को पढ़ लिया है और पुष्टि/हस्ताक्षर किया है.",
      },

      // { type: 'checkbox', content: "I am aware that purchase of this policy is not essential for Getting any kind of bonus , Payout of any Life insurance policy Gifts / Loans / Overdraft. Life insurance is a standalone product and is neither a fixed deposit nor loan nor is it linked to any other banking products." },
    ],
    ulip_points: [
    { type: 'text', content: "पॉलिसी कॉन्ट्रैक्ट के अंतर्गत पॉलिसी के फायदों के अलावा पॉलिसी में कोई अतिरिक्त लाभ नहीं है."},
    { type: 'text', content: "	आप द्वारा खरीदा गया एबीएसएलआई (यूलिप) फायनांस बजट 2021 के तहत जारी नए कर मानकों के अनुसार धारा 10(10 डी) के अंतर्गत भुगतान के समय या पॉलिसी की धनराशि कर से छूट के लिए पात्र नहीं है. फायनांस बजट 2021 के अनुसार, 1 फरवरी 2021 को या बाद में नई खरीदी गई सभी यूनिट लिंक्ड इंश्योरेंस पॉलिसियॉं जिनकी किसी दिए गए वित्त वर्ष के लिए रु.2,50,000 से अधिक की कुल प्रीमियम राशि भुगतेन के समय धारा 10(10डी) के तहत कर रियायत के लिए पात्र नहीं होगी (मृत्यु दावा छोड़कर)."},
    { type: 'text', content: "	यूनिट लिंक्ड प्लान होने के नाते, 5 वर्ष पूर्ण होने के बाद निकासियों की अनुमति होती है, लेकिन हम आपको उत्पाद की संपूर्ण अवधि के लिए प्रीमियम का भुगतान जारी रखने की सलाह देंगे जिसकी अनुपस्थिति में आपका फंड मूल्य लागू शुल्कों के कारण प्रभावित होगा."},
    {type: 'text', content: "पॉलिसी के फायदों का आनंद लेने के लिए पूरी अवधि तक प्रीमियम का भुगतान जारी रखने का हम आपसे निवेदन करते हैं. "},
    {type: 'text', content: "आयकर कानून की धारा 10 (10डी) में हाल में हुए बदलावों के अनुसार, जहां 1 अप्रैल 2023 को या उसके बाद जारी परंपरागत प्लान्स (एन्युइटी, पेंशन और प्योर रिस्क प्लान्स को छोड़कर सभी नॉन-यूनिट लिंक्ड प्लान्स) के मामले में वित्त वर्ष में देय कुल वार्षिक प्रीमियम की राशि रू.5,00,000 से अधिक होती है वहॉं पॉलिसी/पॉलिसियों के लाभ मृत्यु के मामले को छोड़कर धारा 10 (10डी) के अंतर्गत रियायत के लिए पात्र नहीं होगी. ग्राहक से आयकर कानून या अनिवासी ग्राहक के मामले में विदेशी न्याय क्षेत्रों के अंतर्गत उनकी व्यक्तिगत कर देयताओं के संदर्भ में कर सलाहकारी से सलाह लेने का निवेदन किया जाता है."},
    {type: 'checkbox', content: "मैं एतद्द्वारा पुष्टि करता हूँ कि मैने पहले अपने द्वारा ली गई सभी पूर्व विद्यमान पॉलिसियों के विवरणों की घोषणा इस पॉलिसी के लिए आवेदन करते समय आवेदन पत्र में कर दी है."},
    ],
    hdfc_par_and_non_par_points: [
      {
        type: "text",
        content:
          "पॉलिसी के फायदों का आनंद लेने के लिए पूरी अवधि तक प्रीमियम का भुगतान जारी रखने का हम आपसे निवेदन करते हैं. हम आपको सूचित करना चाहेंगे कि गारंटीशदुा मनीबैक/आय को छोड़कर, अन्य भुगतान जैसे बोनस, परिपक्वता लाभ या समर्पण लाभ की 100% गारंटी नहीं है और यह गारंटीशुदा और गैर-गारंटीशुदा पहलू दोनों का मेल है. हम इस पर अधिक विवरणों के लिए लाभ का उदाहरण और पॉलिसी दस्तावेज पढ़ने का निवेदन करते हैं. कृपया ध्यान दें कि पॉलिसी अवधि और प्रीमियम भुगतान अवधि पूर्ण होने से पहले पॉलिसी समर्पित करना यानी परिपक्वता पूर्व समर्पण यानी भुगतान के शुरू होने से पहले या बाद में पॉलिसी समर्पित करने के कारण भुगतान राशि उदाहरण में दिए गए परिपक्वता मूल्य की तुलना में उल्लेखनीय रूप से कम हो जायेगी. अतिरिक्त विवरणों के लिए कृपया लागू लॉक इन अवधि को समझने और भुगतान शुरू होने से पहले और बाद में देय समर्पण मूल्य के संबंध में लाभ का उदाहरण देखें. प्राथमिक पॉलिसी के प्रति प्रीमियमों का भुगतान नहीं किए जाने के मामले में, राइडर लाभ भी समाप्त हो जाएगा.",
      },
      {
        type: "text",
        content:
          "आयकर कानून की धारा 10 (10डी) में हाल में हुए बदलावों के अनुसार, जहां 1 अप्रैल 2023 को या उसके बाद जारी परंपरागत प्लान्स (एन्युइटी, पेंशन और प्योर रिस्क प्लान्स को छोड़कर सभी नॉन-यूनिट लिंक्ड प्लान्स) के मामले में वित्त वर्ष में देय कुल वार्षिक प्रीमियम की राशि रू.5,00,000 से अधिक होती है वहॉं पॉलिसी/पॉलिसियों के लाभ मृत्यु के मामले को छोड़कर धारा 10 (10डी) के अंतर्गत रियायत के लिए पात्र नहीं होगी. ग्राहक से आयकर कानून या अनिवासी ग्राहक के मामले में विदेशी न्याय क्षेत्रों के अंतर्गत उनकी व्यक्तिगत कर देयताओं के संदर्भ में कर सलाहकारी से सलाह लेने का निवेदन किया जाता है.",
      },
      
      {
        type: "checkbox",
        content:
          "मैं एतद्द्वारा पुष्टि करता हूँ कि मैने पहले अपने द्वारा ली गई सभी पूर्व विद्यमान पॉलिसियों के विवरणों की घोषणा इस पॉलिसी के लिए आवेदन करते समय आवेदन पत्र में कर दी है.हम पॉलिसी कन्वर्ज़न के लिए आगे बढ़ेंगे जो किसी भी बकाया आवश्यकताओं को पूरा करने के अधीन है. यदि आप पॉलिसी की शर्तों के साथ संतुष्ट नहीं हैं या कोई बदलाव चाहते हैं तो आपके पास फ्री लुक अवधि के अंदर हमसे वापस संपर्क करने का विकल्प है, जहॉं आपकी पॉलिसी में फ्रीलुक अवधि आपके कागजी पॉलिसी दस्तावेज की प्राप्ति से 15 दिन है, जब कि ई-इंश्योरेंस अकाउंट में आपकी पॉलिसी जमा होने के दिनांक से 30 दिन है.हम पॉलिसी जारी करने के दिनांक से 7 कार्य दिवसों के अंदर आपको पॉलिसी दस्तावेज भेज देंगे. यदि आपने ई-पॉलिसी का चयन किया है तो आपको अपने ई-इंश्योरेंस अकाउंट में डिमटीरियलाइज़्ड पॉलिसी दस्तावेज मिल जाएगा. आदित्य बिरला सन लाइफ आपको माय इंश्योरेंस के रूप में जानी जानेवाली ऑनलाइन सेवा प्रदान करती है जो संपर्क विवरण अपडेशन (अद्यतनीकरण), प्रीमियम भुगतान, फंड मूल्य विवरण जांचने जैसी सुविधाएँ हासिल करने में मदद करता है. अपना रजिस्ट्रेशन करने के लिए कृपया हमारी वेबसाइट www.adityabirlacapital.com पर लॉग ऑन करें. विस्तृत जानकारी के लिए, कृपया पॉलिसी दस्तावेज पढ़ें. आप हमारे टोल फ्री कस्टमर सर्विस नंबर 18002707000 पर भी कॉल कर सकते हैं.मै एतद्द्वारा पुष्टि करता हूँ कि मैने प्रस्ताव फॉर्म भरते समय लाइफ इंश्योरेंस सूटेबिलिटी प्रोफाइलर यानी उसमें वर्णित वन पेज वैरिफिकेशन फॉर्म के साथ इनवेस्टमेंट रिस्क प्रोफाइल को पढ़ लिया है और पुष्टि/हस्ताक्षर किया है.",
      },
    ],
    par_and_non_par_points: [
      {type: 'text', content: 'पॉलिसी के फायदों का आनंद लेने के लिए पूरी अवधि तक प्रीमियम का भुगतान जारी रखने का हम आपसे निवेदन करते हैं. हम आपको सूचित करना चाहेंगे कि गारंटीशदुा मनीबैक/आय को छोड़कर, अन्य भुगतान जैसे बोनस, परिपक्वता लाभ या समर्पण लाभ की 100% गारंटी नहीं है और यह गारंटीशुदा और गैर-गारंटीशुदा पहलू दोनों का मेल है. हम इस पर अधिक विवरणों के लिए लाभ का उदाहरण और पॉलिसी दस्तावेज पढ़ने का निवेदन करते हैं.'},
      {type: 'text', content: "आयकर कानून की धारा 10 (10डी) में हाल में हुए बदलावों के अनुसार, जहां 1 अप्रैल 2023 को या उसके बाद जारी परंपरागत प्लान्स (एन्युइटी, पेंशन और प्योर रिस्क प्लान्स को छोड़कर सभी नॉन-यूनिट लिंक्ड प्लान्स) के मामले में वित्त वर्ष में देय कुल वार्षिक प्रीमियम की राशि रू.5,00,000 से अधिक होती है वहॉं पॉलिसी/पॉलिसियों के लाभ मृत्यु के मामले को छोड़कर धारा 10 (10डी) के अंतर्गत रियायत के लिए पात्र नहीं होगी. ग्राहक से आयकर कानून या अनिवासी ग्राहक के मामले में विदेशी न्याय क्षेत्रों के अंतर्गत उनकी व्यक्तिगत कर देयताओं के संदर्भ में कर सलाहकारी से सलाह लेने का निवेदन किया जाता है."},
     {type: 'text', content: 'कृपया ध्यान दें कि पॉलिसी अवधि और प्रीमियम भुगतान अवधि पूर्ण होने से पहले पॉलिसी समर्पित करना यानी परिपक्वता पूर्व समर्पण यानी भुगतान के शुरू होने से पहले या बाद में पॉलिसी समर्पित करने के कारण भुगतान राशि उदाहरण में दिए गए परिपक्वता मूल्य की तुलना में उल्लेखनीय रूप से कम हो जायेगी. अतिरिक्त विवरणों के लिए कृपया लागू लॉक इन अवधि को समझने और भुगतान शुरू होने से पहले और बाद में देय समर्पण मूल्य के संबंध में लाभ का उदाहरण देखें. प्राथमिक पॉलिसी के प्रति प्रीमियमों का भुगतान नहीं किए जाने के मामले में, राइडर लाभ भी समाप्त हो जाएगा.'},
     {type: 'text', content: "हम पॉलिसी कन्वर्ज़न के लिए आगे बढ़ेंगे जो किसी भी बकाया आवश्यकताओं को पूरा करने के अधीन है. यदि आप पॉलिसी की शर्तों के साथ संतुष्ट नहीं हैं या कोई बदलाव चाहते हैं तो आपके पास फ्री लुक अवधि के अंदर हमसे वापस संपर्क करने का विकल्प है, जहॉं आपकी पॉलिसी में फ्रीलुक अवधि आपके कागजी पॉलिसी दस्तावेज की प्राप्ति से 15 दिन है, जब कि ई-इंश्योरेंस अकाउंट में आपकी पॉलिसी जमा होने के दिनांक से 30 दिन है."},
     {type: 'checkbox', content: "मैं एतद्द्वारा पुष्टि करता हूँ कि मैने पहले अपने द्वारा ली गई सभी पूर्व विद्यमान पॉलिसियों के विवरणों की घोषणा इस पॉलिसी के लिए आवेदन करते समय आवेदन पत्र में कर दी है."},
   
    ],
    common_points_end: [
      {
        type: "text",
        content:
          "कृपया ध्यान रहे कि पॉलिसी अवधि और प्रीमियम भुगतान अवधि की पूर्णता से पहले पॉलिसी समर्पित करने से उदाहरण में दिए गए परिपक्वता मूल्य की तुलना में उल्लेखनीय रूप से कमतर भुगतान होगा. अतिरिक्त विवरणों के लिए कृपया लाभ का उदाहरण देखें. प्राथमिक पॉलिसी के प्रति प्रीमियमों का भुगतान नहीं किए जाने के मामले में, राइडर लाभ भी समाप्त हो जाएगा.",
      },
      {
        type: "text",
        content:
          "हम पॉलिसी कन्वर्ज़न के लिए आगे बढ़ेंगे जो किसी भी बकाया आवश्यकताओं को पूरा करने के अधीन है. यदि आप पॉलिसी की शर्तों के साथ संतुष्ट नहीं हैं या कोई बदलाव चाहते हैं तो आपके पास फ्री लुक अवधि के अंदर हमसे वापस संपर्क करने का विकल्प है, जहॉं आपकी पॉलिसी में फ्रीलुक अवधि आपके कागजी पॉलिसी दस्तावेज की प्राप्ति से 15 दिन है, जब कि ई-इंश्योरेंस अकाउंट में आपकी पॉलिसी जमा होने के दिनांक से 30 दिन है.",
      },
    ],
  },
  landing_page: {
    start: "स्टार्ट",
    hi: "नमस्ते ",
    heading_1a: "आदित्य बिरला सन लाइफ इंश्योरेंस परिवार में आपका स्वागत है ",
    heading_1b: "आपका आवेदन संख्या है ",
  },
  personal_detail_page: {
    personal_title: "व्यक्तिगत विवरण",
    application_number: "आवेदन क्रमांक",
    policy_number: "पॉलिसी धारक का नाम",
    owner_DOB: "पॉलिसी धारक की जन्मतिथि",
    life_insured: "बीमित व्यक्ति",
    insured_DOB: "बीमित व्यक्ति की जन्म की तारीख",
    nominee_name: "नॉमिनी का नाम",
    income: "पॉलिसी धारक की आय",
    occupation: "पॉलिसी धारक का व्यवसाय",
    email: "ईमेल पता",
    contact_number: "मोबाइल नंबर",
    address: "पता",
    city_state: "शहर / राज्य",
    pinCode: "पिन कोड",
    hdfcCheckBox:
      "मैं एतद्द्वारा एचडीएफसी बैंक को अपनी व्यक्तिगत जानकारी जैसे फोन नंबर, ईमेल आईडी, पता, नॉन कैश क्रेडिट, प्रोफाइल इत्यादि इंश्योरेंस कंपनी के साथ साझा करने हेतु सहमति देता/देती हूं ताकि मेरे इंश्योरेंस के प्रस्ताव की प्रक्रिया अधिक तेजी से की जा सके. मैं एतद्द्वारा पुष्टि करता हूं कि यह इंश्योरेंस खरीदते समय किसी भी अन्य बैंकिंग उत्पाद/ सेवा के लिए सेल्स प्रतिनिधि द्वारा कोई वादा नहीं किया गया था.",
    info: "आप उपरोक्त पॉलिसी विवरण में से किसी के साथ सहमत नहीं है तो असहमत बटन क्लिक करें",
  },
  photo_proof_page: {
    confirmation: "पुष्टीकरण",
    subTitle_1a: "आप पुष्टि करते हैं कि ",
    subTitle_1b: " पिछले पृष्ठ में दिए गए विवरण सही हैं।",
    subTitle_2: "फोटो कैप्चर करने के लिए कृपया कैप्चर बटन पर क्लिक करें।",
    personal: "वैयक्तिक",
    policy: "पॉलिसी",
  },
  policy_detail_page: {
    policy_title: "पॉलिसी विवरण",
    plan_name: "योजना का नाम",
    payment: "भुगतान आवृत्ति",
    policy_term: "पॉलिसी अवधि",
    years: " वर्ष",
    premium_payment: "प्रीमियम भुगतान अवधि",
    premium_amount: "प्रीमियम राशि",
    sum_assured: "बीमा राशि",
    purpose_of_insurance: "बीमा का उद्देश्य",
    application_no: "आवेदन संख्या",
    plan_type: "योजना प्रकार",
    info: "आप उपरोक्त पोलिसी विवरण में से किसी के साथ सहमत नहीं है तो असहमत बटन क्लिक करें",
  },
  thank_you_page: {
    thank_you_title: "शुक्रिया",
    message1:
      "आपके बहुमूल्य समय के लिए, आपका सेल्स एग्जीक्यूटिव शीघ्र ही आपसे संपर्क करेगा",
    message2:
      "आपके कीमती समय के लिए। हम आपके पसंदीदा जीवन बीमाकर्ता के रूप में आदित्य बिरला सन लाइफ इंश्योरेंस को चुनने के आपके निर्णय की सराहना करते हैं।",
    message3: "आपका आवेदन संख्या है ",
  },
  verification_page: {
    verification_title: "सत्यापन",
    verification_sub_title: "कृपया नीचे विवरण दर्ज करें",
    verify_dob: "बीमित व्यक्ति की जन्मतिथि",
    verify_phone: "प्रोपोज़र का फ़ोन नंबर",
    language: "भाषा",
    otp_title: "अपने नंबर पर भेजे गए ओटीपि को दर्ज करें",
    otp_placeHolder: "ओटीपि",
    otp_disclaimer: "पंजीकृत मोबाइल नंबर पर ओटीपी भेजा जाएगा",
    seconds_left: " सेकंड शेष..",
    errorMsg1: "आपने सभी प्रयासों को पार कर लिया है। कृपया",
    errorMsg12: "पर वापस कॉल करें और सही विवरण दर्ज करें।",
    errorMsg2: "कुछ गड़बड़ हुई है। कृपया दोबारा प्रयास करें।",
    incorrectMsg: "गलत ओटीपी। कृपया पुन: प्रयास करें।",
    sendOtpAgain: "फिर से भेजें",
    wrongDate: "दर्ज की गई जन्म तिथि गलत है। कृपया पुन: प्रयास करें।",
    wrongPhone: "दर्ज किया गया फ़ोन गलत है। कृपया पुन: प्रयास करें।",
    wrongLanguage: "चयनित भाषा गलत है। कृपया पुन: प्रयास करें।",
  },
  video_proof_page: {
    video_title: "वीडियो उपक्रम",
    detail_1: "कृपया रिकॉर्ड बटन पर क्लिक करें और नीचे दिया गया पाठ पढ़ें",
    detail_2_a: "मैं ",
    detail_2_b: ",यह पुष्टि करता हूँ की मैंने",
    detail_3:
      " के विवरण को समझ लिया है और मैं इसके बताए गए नियमों और शर्तों से सहमत हूँ ।मैं अपने आवेदन को प्रोसेस कराने के लिए सहमत हूं। मेरा मोबाइल नंबर है ",
    recordFailure:
      "क्षमा करें, वीडियो सफलतापूर्वक अपलोड नहीं किया गया था। कृपया फिर से अपलोड करने के लिए सबमिट बटन पर क्लिक करें।",
    permissionMsg: "वीडियो अनुमति अस्वीकृत, कृपया वीडियो के लिए अनुमति दें",
    record_again: "कृपया फिर से रिकॉर्ड करें",
  },
  photo_dialog_page: { confirm_title: "ली गई तस्वीर की पुष्टि करें" },
  buttons: {
    initiate_recorder: "रिकॉर्डर आरंभ करें",
    retake: "रिटेक",
    confirm: "पुष्टि करें",
    stop: "रुकें",
    next: "नेक्स्ट",
    back: "वापस",
    submit: "सब्मिट",
    resend: "पुन: भेजें",
    agree: "सहमत",
    disagree: "असहमत",
    capture: "कैप्चर",
    record: "रिकॉर्ड",
    re_record: "फिर से रिकॉर्ड",
    verify: "वेरीफाई",
    replay: "रीप्ले"
  },
};

export const PunjabiLanguageContent = {
  flowComplete: "ਤੁਸੀਂ ਪਹਿਲਾਂ ਹੀ ਪ੍ਰਕਿਰਿਆ ਪੂਰੀ ਕਰ ਲਈ ਹੈ",
  disagree_page: {
    disagree_title: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੀ ਅਸਹਿਮਤੀ ਦਾ ਕਾਰਨ ਚੁਣੋ",
    remarks: "ਰੇਮਾਰ੍ਕ੍ਸ",
    please_enter_remarks: "ਕਿਰਪਾ ਕਰਕੇ ਟਿੱਪਣੀਆਂ ਦਰਜ ਕਰੋ",
    personal_title: "Personal Details Disagree",
    policy_title: "Policy Details Disagree",
    reason:
      "ਕਿਰਪਾ ਕਰਕੇ ਅਸਹਿਮਤੀ ਦਾ ਕਾਰਨ ਚੁਣੋ ਅਤੇ ਟੈਕਸਟ ਬਾਕਸ ਵਿੱਚ ਵੇਰਵੇ ਦਰਜ ਕਰੋ।",
  },
  error_page: {
    sorry: "Sorry ",
    something_went_wrong: "Something went wrong.",
  },

  information_page: {
    info_title: "ਯਾਦ ਰੱਖਣ ਲਈ ਮਹੱਤਵਪੂਰਨ ਨੁਕਤੇ",
    common_points_start: [
      {
        type: "text",
        content:
          "Kindly read the important information displayed on the screen.",
      },
      {
        type: "embeddedHtml",
        content:
          "We will Dispatch your policy document with-in 7 working days from the policy issuance date. If you have opted for an e-policy, you will receive the dematerialised policy document in your e-insurance account. Aditya Birla Sun Life provides you with an online service known as My Insurance which helps you avail facilities like contact detail updation, premium payments, check fund value details etc. Kindly log onto our website <a href='www.adityabirlasunlifeinsurance.com'>www.adityabirlasunlifeinsurance.com</a> to register yourself. For detailed information, kindly go through the policy document .You can also call our toll free customer service number <a href='tel:18002707000' style={{ textDecoration: 'none' }}> 1800 270 7000 </a>",
      },
      {
        type: "text",
        content:
          "Life insurance is a standalone product and is neither a fixed deposit nor loan nor is it linked to any other banking products. Other than the policy benefits as specifically mentioned under the policy contract, there are no additional benefits under the policy. ",
      },
    ],
    ulip_points: [
      {
        type: "text",
        content:
          "ABSLI (ULIP) being purchased by you, is NOT eligible for exemption under tax at the time of payout or policy proceeds under section 10(10 D) as per the new tax norms issued under the Finance Budget 2021. As per the Finance Budget 2021, all Unit Linked Insurance policies newly purchased on or after 1st Feb 2021 with an aggregate premium exceeding Rs.2,50,000/- for a given financial year , shall NOT be eligible for tax exemption under section 10 (10 D) at the time of payout (except death claim).",
      },
      {
        type: "text",
        content:
          "Being an unit linked plan, withdrawals are allowed post completion of 5 years, we however would advice you to continue paying the premium for the entire term of the product in absence of same your fund value will get impacted due to charges applicable.",
      },
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy.",
      },
      {
        type: "text",
        content:
          "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy.",
      },
    ],
    par_and_non_par_points: [
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy. We would like to inform you that except for guaranteed moneybacks/income , other pay out like bonus , maturity benefit or surrender benefit are not 100% guaranteed and is a combination of both guaranteed and non-guaranteed elements. We request you to refer the benefit illustration and policy document for more details on the this.",
      },
      {
        type: "text",
        content:
          "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer",
      },
      {
        type: "text",
        content:
          'Please note that surrendering the policy before the completion of the policy term and premium paying term i.e pre- mature surrenders like surrendering the policy before or after the start of the payout will lead to significantly lower payout than the illustrated maturity value" For additional details kindly refer the Benefit illustration". with respect to understanding lock-in period as applicable & surrender value payable before and after the start of the payout. In case of non-payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.',
      },
      {
        type: "text",
        content:
          "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document 30 days from the date of credit of your policy to e-Insurance Account.",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy.",
      },
    ],
    common_points_end: [
      {
        type: "text",
        content:
          "	Please note that surrendering the policy before the completion of the policy term and premium paying term will lead to significantly lower pay out than the illustrated maturity value. For additional details kindly refer the Benefit illustration. In case of non- payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.",
      },
      {
        type: "text",
        content:
          "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document   30 days from the date of credit of your policy to e-Insurance Account.",
      },
    ],
  },
  landing_page: {
    start: "ਸ਼ੁਰੂ ਕਰੋ",
    hi: "ਹੈਲੋ ",
    heading_1a: "ਆਦਿਤਿਆ ਬਿਰਲਾ ਸਨ ਲਾਈਫ ਇੰਸ਼ੋਰੈਂਸ ਪਰਿਵਾਰ ਵਿੱਚ ਤੁਹਾਡਾ ਸੁਆਗਤ ਹੈ",
    heading_1b: "ਤੁਹਾਡੀ ਅਰਜ਼ੀ ਨੰਬਰ ਹੈ ",
  },
  personal_detail_page: {
    personal_title: "ਨਿੱਜੀ ਵੇਰਵੇ",
    application_number: "ਐਪਲੀਕੇਸ਼ਨ ਨੰਬਰ",
    policy_number: "ਨੀਤੀ ਦਾ ਮਾਲਕ",
    owner_DOB: "ਮਾਲਕ DOB",
    life_insured: "ਜੀਵਨ ਬੀਮਤ",
    insured_DOB: "ਬੀਮਾਯੁਕਤ DOB",
    nominee_name: "ਨਾਮਜ਼ਦ ਨਾਮ",
    income: "ਮਾਲਕ ਦੀ ਆਮਦਨ",
    occupation: "ਮਾਲਕ ਦਾ ਕਿੱਤਾ",
    email: "ਈ-ਮੇਲ ਈਦ",
    contact_number: "ਸੰਪਰਕ ਨੰਬਰ",
    address: "ਪਤਾ",
    city_state: "ਸ਼ਹਿਰ/ਰਾਜ",
    pinCode: "ਪਿੰਨ ਕੋਡ",
    hdfcCheckBox:
      "ਮੈਂ ਇਸ ਦੁਆਰਾ HDFC ਬੈਂਕ ਨੂੰ ਆਪਣੀ ਨਿੱਜੀ ਜਾਣਕਾਰੀ ਜਿਵੇਂ ਕਿ ਫ਼ੋਨ ਨੰਬਰ, ਈ-ਮੇਲ ਆਈ.ਡੀ., ਪਤਾ, ਗੈਰ-ਨਕਦ ਕ੍ਰੈਡਿਟ, ਪ੍ਰੋਫਾਈਲ, ਆਦਿ ਨੂੰ ਬੀਮਾ ਕੰਪਨੀ ਨਾਲ ਸਾਂਝਾ ਕਰਨ ਲਈ ਸਹਿਮਤੀ ਦਿੰਦਾ ਹਾਂ ਤਾਂ ਜੋ ਮੇਰੇ ਬੀਮਾ ਪ੍ਰਸਤਾਵ ਦੀ ਤੇਜ਼ੀ ਨਾਲ ਪ੍ਰਕਿਰਿਆ ਦੀ ਸਹੂਲਤ ਦਿੱਤੀ ਜਾ ਸਕੇ। ਮੈਂ ਇਸ ਦੁਆਰਾ ਪੁਸ਼ਟੀ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ ਕਿ ਇਸ ਬੀਮੇ ਨੂੰ ਖਰੀਦਣ ਵੇਲੇ ਵਿਕਰੀ ਪ੍ਰਤੀਨਿਧੀ ਦੁਆਰਾ ਕਿਸੇ ਹੋਰ ਬੈਂਕਿੰਗ ਉਤਪਾਦ/ਸੇਵਾ ਲਈ ਕੋਈ ਵਾਅਦਾ ਨਹੀਂ ਕੀਤਾ ਗਿਆ ਸੀ।",
    info: 'ਜੇਕਰ ਸਕ੍ਰੀਨ "ਤੇ ਦਿਖਾਈ ਗਈ ਸਾਰੀ ਜਾਣਕਾਰੀ ਸਹੀ ਹੈ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ "ਸਹਿਮਤ" "ਤੇ ਕਲਿੱਕ ਕਰੋ ਨਹੀਂ ਤਾਂ "ਅਸਹਿਮਤ" "ਤੇ ਕਲਿੱਕ ਕਰੋ।',
  },
  photo_proof_page: {
    confirmation: "Confirmation",
    subTitle_1a: "You confirm that the ",
    subTitle_1b: " Details given in the previous page are correct.",
    subTitle_2: "Please click on the Capture button to capture photo.",
    personal: "Personal",
    policy: "Policy",
  },
  policy_detail_page: {
    policy_title: "ਨੀਤੀ ਵੇਰਵੇ",
    plan_name: "ਯੋਜਨਾ ਦਾ ਨਾਮ",
    payment: "ਭੁਗਤਾਨ ਦੀ ਬਾਰੰਬਾਰਤਾ",
    policy_term: "ਨੀਤੀ ਦੀ ਮਿਆਦ",
    years: " ਸਾਲ",
    premium_payment: "ਪ੍ਰੀਮੀਅਮ ਭੁਗਤਾਨ ਦੀ ਮਿਆਦ",
    premium_amount: "ਪ੍ਰੀਮੀਅਮ ਦੀ ਰਕਮ",
    sum_assured: "ਬੀਮੇ ਦੀ ਰਕਮ",
    purpose_of_insurance: "ਬੀਮੇ ਦਾ ਉਦੇਸ਼",
    application_no: "ਐਪਲੀਕੇਸ਼ਨ ਨੰਬਰ",
    plan_type: "ਯੋਜਨਾ ਦੀ ਕਿਸਮ",
    info: 'ਜੇਕਰ ਸਕ੍ਰੀਨ "ਤੇ ਦਿਖਾਈ ਗਈ ਸਾਰੀ ਜਾਣਕਾਰੀ ਸਹੀ ਹੈ, ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ "ਸਹਿਮਤ" "ਤੇ ਕਲਿੱਕ ਕਰੋ ਨਹੀਂ ਤਾਂ "ਅਸਹਿਮਤ" "ਤੇ ਕਲਿੱਕ ਕਰੋ।',
  },
  thank_you_page: {
    thank_you_title: "Thank You",
    message1:
      "for your valuable time, your sales representative will get in touch with you shortly",
    message2:
      "for your valuable time. We appreciate your decision for choosing Aditya Birla Sun Life Insurance as your preferred life insurer.",
    message3: "Your application number is ",
  },
  verification_page: {
    verification_title: "ਪੁਸ਼ਟੀਕਰਨ",
    verification_sub_title: "ਕਿਰਪਾ ਕਰਕੇ ਹੇਠਾਂ ਦਿੱਤੇ ਵੇਰਵੇ ਦਾਖਲ ਕਰੋ",
    verify_dob: "ਜੀਵਣਾ ਬਿਮੇ ਦੀ ਜਨਮਾ ਮਿਟੀ",
    verify_phone: "ਪ੍ਰਸਤਾਵਕ ਦਾ ਫ਼ੋਨ ਨੰਬਰ",
    language: "ਭਾਸ਼ਾ",
    otp_title: "ਆਪਣੇ ਨੰਬਰ 'ਤੇ ਭੇਜਿਆ ਗਿਆ OTP ਦਾਖਲ ਕਰੋ",
    otp_placeHolder: "OTP",
    seconds_left: " seconds left..",
    errorMsg1:
      "ਤੁਸੀਂ ਸਾਰੀਆਂ ਕੋਸ਼ਿਸ਼ਾਂ ਨੂੰ ਪਾਰ ਕਰ ਲਿਆ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਵਾਪਸ ਕਾਲ ਕਰੋ",
    errorMsg2: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ, ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    errorMsg12: " ਅਤੇ ਸਹੀ ਵੇਰਵੇ ਦਰਜ ਕਰੋ।",
    incorrectMsg: "ਗਲਤ OTP। ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ.",
    sendOtpAgain: "OTP ਦੁਬਾਰਾ ਭੇਜਿਆ ਗਿਆ ਹੈ।",
    wrongDate: "ਦਰਜ ਕੀਤੀ ਜਨਮ ਮਿਤੀ ਗਲਤ ਹੈ। ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ.",
    wrongPhone: "ਦਾਖਲ ਕੀਤਾ ਫ਼ੋਨ ਗਲਤ ਹੈ। ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ.",
    wrongLanguage: "ਚੁਣੀ ਗਈ ਭਾਸ਼ਾ ਗਲਤ ਹੈ। ਮੁੜ ਕੋਸ਼ਿਸ ਕਰੋ ਜੀ.",
    otp_disclaimer: "ਰਜਿਸਟਰਡ ਮੋਬਾਈਲ ਨੰਬਰ 'ਤੇ OTP ਭੇਜਿਆ ਜਾਵੇਗਾ",
  },
  video_proof_page: {
    video_title: "Video Undertaking",
    detail_1: "Please Click on record button and read out the below Text",
    detail_2_a: "I ",
    detail_2_b: ", hereby confirm that I have understood the details of",
    detail_3:
      " and agree to terms and conditions explained to me. I hereby agree to process my application. My mobile number is ",
    recordFailure:
      "Sorry, the video wasn't uploaded successfully. Please click on the submit button to upload again.",
    permissionMsg: "Video Permission denied, please give permission for video",
    record_again: "Please record again",
  },
  photo_dialog_page: { confirm_title: "Confirm the picture taken" },
  buttons: {
    initiate_recorder: "Initiate Recorder",
    retake: "Retake",
    confirm: "Confirm",
    stop: "Stop",
    next: "ਅਗਲਾ",
    back: "ਵਾਪਸ",
    submit: "Submit",
    resend: "Resend",
    agree: "ਸਹਿਮਤ ਹੋ",
    disagree: "ਅਸਹਿਮਤ",
    capture: "Capture",
    record: "Record",
    re_record: "Re-record",
    verify: "Verify",
  },
};

export const GujratiLanguageContent = {
  flowComplete: "તમે પહેલાથી જ પ્રક્રિયા પૂર્ણ કરી લીધી છે",
  disagree_page: {
    disagree_title: "કૃપા કરીને તમારા અસંમતિ માટેનું કારણ(કો) પસંદ કરો",
    remarks: "ટીકા",
    please_enter_remarks: "કૃપા કરીને ટિપ્પણીઓ દાખલ કરો",
    personal_title: "વ્યક્તિગત વિગતો અસંમત",
    policy_title: "નીતિ વિગતો અસંમત",
    reason:
      "કૃપા કરીને અસંમતિનું કારણ પસંદ કરો અને ટેક્સ્ટબોક્સમાં વિગતો દાખલ કરો.",
  },
  error_page: {
    sorry: "માફ કરશો ",
    something_went_wrong: "કંઈક ખોટું થયું.",
  },

  information_page: {
    info_title: "યાદ રાખવા માટે મહત્વપૂર્ણ મુદ્દાઓ",
    common_points_start: [
      {
        type: "text",
        content: "કૃપા કરીને સ્ક્રીન પર પ્રદર્શિત મહત્વપૂર્ણ માહિતી વાંચો.",
      },
      {
        type: "embeddedHtml",
        content:
          "અમે તમારા પોલિસી દસ્તાવેજને પોલિસી જારી કરવાની તારીખથી 7 કામકાજના દિવસોમાં મોકલીશું. જો તમે ઈ-પોલીસી પસંદ કરી હોય, તો તમને તમારા ઈ-વીમા ખાતામાં ડીમટીરિયલાઈઝ્ડ પોલિસી દસ્તાવેજ પ્રાપ્ત થશે. આદિત્ય બિરલા સન લાઈફ તમને માય ઈન્સ્યોરન્સ તરીકે ઓળખાતી ઓનલાઈન સેવા પ્રદાન કરે છે જે તમને સંપર્ક વિગતો અપડેટ, પ્રીમિયમ ચૂકવણી, ફંડ મૂલ્યની વિગતો વગેરે જેવી સુવિધાઓનો લાભ મેળવવામાં મદદ કરે છે. કૃપા કરીને અમારી વેબસાઈટ પર લોગઈન કરો.<a href='www.adityabirlasunlifeinsurance.com'>www.adityabirlasunlifeinsurance.com</a> તમારી જાતને નોંધણી કરવા માટે. વિગતવાર માહિતી માટે, કૃપા કરીને પોલિસી દસ્તાવેજ પર જાઓ. તમે અમારા ટોલ ફ્રી ગ્રાહક સેવા નંબર પર પણ કૉલ કરી શકો છો <a href='tel:18002707000' style={{ textDecoration: 'none' }}> 1800 270 7000 </a>",
      },
      {
        type: "text",
        content:
          "જીવન વીમો એ એક સ્વતંત્ર ઉત્પાદન છે અને તે ન તો ફિક્સ્ડ ડિપોઝિટ છે કે ન તો લોન છે અને ન તો તે અન્ય કોઈ બેંકિંગ ઉત્પાદનો સાથે જોડાયેલી છે. પોલિસી કોન્ટ્રાક્ટ હેઠળ ખાસ ઉલ્લેખિત પોલિસી લાભો સિવાય, પોલિસી હેઠળ કોઈ વધારાના લાભો નથી. ",
      },
    ],
    ulip_points: [
      {
        type: "text",
        content:
          "એબીએસએલઆઈ (યુલિપ) તમારા દ્વારા ખરીદવામાં આવી રહી છે, તે નાણાંકીય બજેટ 2021 હેઠળ જારી કરાયેલા નવા કર ધારાધોરણો અનુસાર ચૂકવણીના સમયે અથવા કલમ 10(10 ડી) હેઠળ પોલિસીની કાર્યવાહીમાં કર હેઠળ મુક્તિ માટે પાત્ર નથી. નાણાંકીય બજેટ 2021 મુજબ , આપેલ નાણાકીય વર્ષ માટે રૂ. 2,50,000/-થી વધુના કુલ પ્રીમિયમ સાથે 1લી ફેબ્રુઆરી 2021ના રોજ અથવા તે પછી નવી ખરીદેલી તમામ યુનિટ લિંક્ડ વીમા પૉલિસી, તે સમયે કલમ 10 (10 ડી) હેઠળ કર મુક્તિ માટે પાત્ર નહીં હોય. ચૂકવણી (મૃત્યુના દાવા સિવાય).",
      },
      {
        type: "text",
        content:
          "એક યુનિટ લિંક્ડ પ્લાન હોવાને કારણે, 5 વર્ષ પૂરા થયા પછી ઉપાડની મંજૂરી છે, જો કે અમે તમને પ્રોડક્ટની સમગ્ર મુદત માટે પ્રીમિયમ ચૂકવવાનું ચાલુ રાખવાની સલાહ આપીશું, તે જ ગેરહાજરીમાં તમારા ફંડ મૂલ્યને લાગુ પડતા શુલ્કને કારણે અસર થશે.",
      },
      {
        type: "text",
        content:
          "અમે તમને પૉલિસીના લાભોનો આનંદ માણવા માટે સમગ્ર મુદત માટે પ્રીમિયમ ચૂકવવાનું ચાલુ રાખવા વિનંતી કરીએ છીએ.",
      },
      {
        type: "text",
        content:
          "આવકવેરા કાયદાની કલમ 10 (10D) માં તાજેતરના ફેરફારો મુજબ, જ્યાં પરંપરાગત યોજનાઓના કિસ્સામાં નાણાકીય વર્ષમાં ચૂકવવાપાત્ર એકંદર વાર્ષિક પ્રીમિયમની રકમ (વાર્ષિક, પેન્શન અને શુદ્ધ જોખમ યોજનાઓ સિવાયની તમામ બિન-યુનિટ લિંક્ડ યોજનાઓ) અથવા 1લી એપ્રિલ, 2023 પછી INR 5,00,000 કરતાં વધી ગયેલા પોલિસી/પોલીસીનો લાભ મૃત્યુના કિસ્સામાં સિવાય કલમ 10 (10D) હેઠળ મુક્તિ માટે પાત્ર રહેશે નહીં. બિન-નિવાસી ગ્રાહકના કિસ્સામાં ગ્રાહકને આવકવેરા કાયદા અથવા વિદેશી અધિકારક્ષેત્ર હેઠળ તેની/તેણીની વ્યક્તિગત કર જવાબદારીઓના સંદર્ભમાં કર સલાહકારની સલાહ લેવાની વિનંતી કરવામાં આવે છે.",
      },
      {
        type: "checkbox",
        content:
          "હું આથી પુષ્ટિ કરું છું કે, મેં આ નીતિ માટે અરજી કરતી વખતે અરજી ફોર્મ પર ભૂતકાળમાં મેળવેલી તમામ પૂર્વ-અસ્તિત્વમાં રહેલી નીતિ વિગતો જાહેર કરી છે.",
      },
    ],
    par_and_non_par_points: [
      {
        type: "text",
        content:
          "અમે તમને પૉલિસીના લાભોનો આનંદ માણવા માટે સમગ્ર મુદત માટે પ્રીમિયમ ચૂકવવાનું ચાલુ રાખવા વિનંતી કરીએ છીએ. અમે તમને જણાવવા માંગીએ છીએ કે બાંયધરીકૃત મનીબેક/આવક સિવાય, અન્ય પે આઉટ જેમ કે બોનસ, મેચ્યોરિટી લાભ અથવા શરણાગતિ લાભ 100% ગેરંટી નથી અને તે ગેરંટી અને ગેરંટીડ બંને તત્વોનું સંયોજન છે. અમે તમને આ અંગે વધુ વિગતો માટે લાભનું ઉદાહરણ અને નીતિ દસ્તાવેજનો સંદર્ભ લેવા વિનંતી કરીએ છીએ.",
      },
      {
        type: "text",
        content:
          "આવકવેરા કાયદાની કલમ 10 (10D) માં તાજેતરના ફેરફારો મુજબ, જ્યાં પરંપરાગત યોજનાઓના કિસ્સામાં નાણાકીય વર્ષમાં ચૂકવવાપાત્ર એકંદર વાર્ષિક પ્રીમિયમની રકમ (વાર્ષિક, પેન્શન અને શુદ્ધ જોખમ યોજનાઓ સિવાયની તમામ બિન-યુનિટ લિંક્ડ યોજનાઓ) જારી કરવામાં આવે છે. 1લી એપ્રિલ, 2023 ના રોજ અથવા તે પછી INR 5,00,000 થી વધુ પોલિસી/પોલીસીના લાભો મૃત્યુના કિસ્સામાં સિવાય કલમ 10 (10D) હેઠળ મુક્તિ માટે પાત્ર રહેશે નહીં. ગ્રાહકને કર સલાહકારની સલાહ લેવા વિનંતી કરવામાં આવે છે. બિન-નિવાસી ગ્રાહકના કિસ્સામાં આવકવેરા કાયદા હેઠળ તેની/તેણીની વ્યક્તિગત કર જવાબદારીઓ અથવા વિદેશી અધિકારક્ષેત્રોનો આદર",
      },
      {
        type: "text",
        content:
          'મહેરબાની કરીને નોંધ કરો કે પૉલિસીની મુદત અને પ્રીમિયમ ભરવાની મુદત પૂરી થાય તે પહેલાં પૉલિસી સરેન્ડર કરવી એટલે કે પ્રિ-મેચ્યોર શરણાગતિ જેમ કે ચુકવણીની શરૂઆત પહેલાં અથવા પછી પૉલિસી સરેન્ડર કરવાથી સચિત્ર પરિપક્વતા મૂલ્ય કરતાં નોંધપાત્ર રીતે ઓછું ચૂકવણી થશે" વધારાની વિગતો માટે કૃપા કરીને લાભના ચિત્રનો સંદર્ભ લો". ચૂકવણીની શરૂઆત પહેલાં અને પછી ચૂકવવાપાત્ર લૉક-ઇન અવધિને લાગુ અને સમર્પણ મૂલ્યને સમજવાના સંદર્ભમાં. પ્રાથમિક પૉલિસી તરફ પ્રિમિયમની ચુકવણી ન કરવાના કિસ્સામાં, રાઇડરનો લાભ પણ બંધ થઈ જશે.',
      },
      {
        type: "text",
        content:
          "અમે હવે નીતિ રૂપાંતરણ માટે આગળ વધીશું જે કોઈપણ બાકી આવશ્યકતાઓને પરિપૂર્ણ થવાને આધીન છે. જો તમે પૉલિસીની શરતોથી સંતુષ્ટ ન હોવ અથવા કોઈ ફેરફારની જરૂર હોય, તો તમારી પાસે ફ્રી લૂક પિરિયડની અંદર અમારો સંપર્ક કરવાનો વિકલ્પ છે, જ્યાં તમારી પોલિસીમાં ફ્રીલૂક પિરિયડ તમારા ભૌતિક પોલિસી દસ્તાવેજની પ્રાપ્તિના 30 દિવસથી 15 દિવસનો છે. ઈ-ઈન્શ્યોરન્સ એકાઉન્ટમાં તમારી પોલિસી જમા કરવાની તારીખ.",
      },
      {
        type: "checkbox",
        content:
          "હું આથી પુષ્ટિ કરું છું કે આ પોલિસી માટે અરજી કરતી વખતે મેં ભૂતકાળમાં મારા દ્વારા મેળવેલી તમામ પૂર્વ-અસ્તિત્વમાં રહેલી નીતિ વિગતો જાહેર કરી છે.",
      },
    ],
    common_points_end: [
      {
        type: "text",
        content:
          "	મહેરબાની કરીને નોંધ કરો કે પૉલિસીની મુદત અને પ્રીમિયમ ભરવાની મુદત પૂરી થાય તે પહેલાં પૉલિસી સરેન્ડર કરવાથી સચિત્ર પરિપક્વતા મૂલ્ય કરતાં નોંધપાત્ર રીતે ઓછી ચૂકવણી થશે. વધારાની વિગતો માટે કૃપા કરીને લાભના ચિત્રનો સંદર્ભ લો. પ્રાથમિક પૉલિસી માટે પ્રિમિયમની ચુકવણી ન કરવાના કિસ્સામાં, રાઇડરનો લાભ પણ બંધ થઈ જશે.",
      },
      {
        type: "text",
        content:
          "અમે હવે નીતિ રૂપાંતરણ માટે આગળ વધીશું જે કોઈપણ બાકી આવશ્યકતાઓને પરિપૂર્ણ થવાને આધીન છે. જો તમે પોલિસીની શરતોથી સંતુષ્ટ ન હોવ અથવા કોઈપણ ફેરફારની જરૂર હોય, તો તમારી પાસે ફ્રી લુક પિરિયડની અંદર અમારો સંપર્ક કરવાનો વિકલ્પ છે, જ્યાં તમારી પોલિસીમાં ફ્રીલુકનો સમયગાળો તમારા ભૌતિક પોલિસી દસ્તાવેજની પ્રાપ્તિના 30 દિવસના 15 દિવસનો છે. ઈ-ઈન્શ્યોરન્સ એકાઉન્ટમાં તમારી પોલિસી જમા કરવાની તારીખ.",
      },
    ],
  },
  landing_page: {
    start: "શરૂઆત",
    hi: "નમસ્તે",
    heading_1a: "આદિત્ય બિરલા સન લાઇફ ઇન્શ્યોરન્સ પરિવારમાં આપનું સ્વાગત છે",
    heading_1b: "તમારો અરજી નંબર છે ",
  },
  personal_detail_page: {
    personal_title: "અંગત વિગતો",
    application_number: "અરજી નંબર",
    policy_number: "નીતિ માલિક",
    owner_DOB: "માલિક DOB",
    life_insured: "જીવન વીમો",
    insured_DOB: "વીમેદાર DOB",
    nominee_name: "નોમિનીનું નામ",
    income: "માલિકની આવક",
    occupation: "માલિકનો વ્યવસાય",
    email: "ઇમેઇલ ઈદ",
    contact_number: "સંપર્ક નંબર",
    address: "સરનામું",
    city_state: "શહેર/રાજ્ય",
    pinCode: "પીન કોડ",
    hdfcCheckBox:
      "હું આથી HDFC બેંકને મારી અંગત માહિતી જેવી કે ફોન નંબર, ઈ-મેલ આઈડી, સરનામું, નોન-કેશ ક્રેડિટ, પ્રોફાઇલ વગેરે વીમા કંપની સાથે શેર કરવા માટે મારી વીમા દરખાસ્તની ઝડપી પ્રક્રિયાને સરળ બનાવવા માટે સંમતિ આપું છું. હું આથી પુષ્ટિ કરું છું કે આ વીમો ખરીદતી વખતે વેચાણ પ્રતિનિધિ દ્વારા કોઈપણ અન્ય બેંકિંગ પ્રોડક્ટ/સેવા માટે કોઈ વચન આપવામાં આવ્યું ન હતું.",
    info: 'જો સ્ક્રીન પર પ્રદર્શિત બધી માહિતી સાચી હોય, તો કૃપા કરીને "સંમત" પર ક્લિક કરો અન્યથા "અસંમત" પર ક્લિક કરો.',
  },
  photo_proof_page: {
    confirmation: "પુષ્ટિકરણ",
    subTitle_1a: "તમે પુષ્ટિ કરો છો કે",
    subTitle_1b: " અગાઉના પાનામાં આપેલી વિગતો સાચી છે.",
    subTitle_2: "ફોટો લેવા માટે કૃપા કરીને કેપ્ચર બટન પર ક્લિક કરો.",
    personal: "અંગત",
    policy: "નીતિ",
  },
  policy_detail_page: {
    policy_title: "નીતિ વિગતો",
    plan_name: "યોજનાનું નામ",
    payment: "ચુકવણી આવર્તન",
    policy_term: "પૉલિસી ટર્મ",
    years: " વર્ષ",
    premium_payment: "પ્રીમિયમ ચુકવણીની મુદત",
    premium_amount: "પ્રીમિયમ રકમ",
    sum_assured: "સમ એશ્યોર્ડ",
    purpose_of_insurance: "વીમાનો હેતુ",
    application_no: "અરજી નંબર",
    plan_type: "યોજનાનો પ્રકાર",
    info: 'જો સ્ક્રીન પર પ્રદર્શિત બધી માહિતી સાચી હોય, તો કૃપા કરીને "સંમત" પર ક્લિક કરો અન્યથા "અસંમત" પર ક્લિક કરો.',
  },
  thank_you_page: {
    thank_you_title: "આભાર",
    message1:
      "તમારા મૂલ્યવાન સમય માટે, તમારો વેચાણ પ્રતિનિધિ ટૂંક સમયમાં તમારો સંપર્ક કરશે",
    message2:
      "તમારા કિંમતી સમય માટે. આદિત્ય બિરલા સન લાઇફ ઇન્સ્યોરન્સને તમારી પસંદગીના જીવન વીમા કંપની તરીકે પસંદ કરવા બદલ અમે તમારા નિર્ણયની પ્રશંસા કરીએ છીએ.",
    message3: "તમારો અરજી નંબર છે",
  },
  verification_page: {
    verification_title: "ચકાસણી",
    verification_sub_title: "કૃપા કરીને નીચેની વિગતો દાખલ કરો",
    verify_dob: "જીવન વીમાધારકની જન્મ તારીખ",
    verify_phone: "પ્રસ્તાવકર્તાનો ફોન નંબર",
    language: "ભાષા",
    otp_title: "તમારા નંબર પર મોકલેલ OTP દાખલ કરો",
    otp_placeHolder: "OTP",
    seconds_left: " seconds left..",
    errorMsg1: "તમે બધા પ્રયત્નો વટાવી દીધા છે. કૃપા કરીને પાછા કૉલ કરો",
    errorMsg2: "કંઈક ખોટું થયું, કૃપા કરીને ફરી પ્રયાસ કરો.",
    errorMsg12: " અને સાચી વિગતો દાખલ કરો.",
    incorrectMsg: "ખોટો OTP. મહેરબાની કરીને ફરીથી પ્રયતન કરો.",
    sendOtpAgain: "OTP ફરીથી મોકલવામાં આવ્યો છે.",
    wrongDate: "દાખલ કરેલ જન્મ તારીખ ખોટી છે. મહેરબાની કરીને ફરીથી પ્રયતન કરો.",
    wrongPhone: "દાખલ કરેલ ફોન ખોટો છે. મહેરબાની કરીને ફરીથી પ્રયતન કરો.",
    wrongLanguage: "પસંદ કરેલી ભાષા ખોટી છે. મહેરબાની કરીને ફરીથી પ્રયતન કરો.",
    otp_disclaimer: "રજિસ્ટર્ડ મોબાઈલ નંબર પર OTP મોકલવામાં આવશે",
  },
  video_proof_page: {
    video_title: "વિડિઓ ઉપક્રમ",
    detail_1: "કૃપા કરીને રેકોર્ડ બટન પર ક્લિક કરો અને નીચેનું લખાણ વાંચો",
    detail_2_a: "હું, ",
    detail_2_b: ", આથી પુષ્ટિ કરું છું કે હું તેની વિગતો સમજી ગયો છું",
    detail_3:
      " અને મને સમજાવેલ નિયમો અને શરતો સાથે સંમત છું. હું આથી મારી અરજી પર પ્રક્રિયા કરવા માટે સંમત છું. મારો મોબાઈલ નંબર છે ",
    recordFailure:
      "માફ કરશો, વિડિઓ સફળતાપૂર્વક અપલોડ કરવામાં આવી ન હતી. ફરીથી અપલોડ કરવા માટે કૃપા કરીને સબમિટ બટન પર ક્લિક કરો.",
    permissionMsg: "વિડિઓ પરવાનગી નકારી, કૃપા કરીને વિડિઓ માટે પરવાનગી આપો",
    record_again: "કૃપા કરીને ફરીથી રેકોર્ડ કરો",
  },
  photo_dialog_page: { confirm_title: "લીધેલા ચિત્રની પુષ્ટિ કરો" },
  buttons: {
    initiate_recorder: "Initiate Recorder",
    retake: "Retake",
    confirm: "Confirm",
    stop: "Stop",
    next: "આગળ",
    back: "પાછળ",
    submit: "Submit",
    resend: "Resend",
    agree: "સંમત",
    disagree: "અસંમત",
    capture: "Capture",
    record: "Record",
    re_record: "Re-record",
    verify: "Verify",
  },
};

export const TeluguLanguageContent = {
  flowComplete: "You have already Completed the process",
  disagree_page: {
    disagree_title: "దయచేసి మీ అసమ్మతికి కారణాన్ని ఎంచుకోండి",
    remarks: "వ్యాఖ్యలు",
    please_enter_remarks: "దయచేసి వ్యాఖ్యలను నమోదు చేయండి",
    personal_title: "Personal Details Disagree",
    policy_title: "Policy Details Disagree",
    reason:
      "దయచేసి అసమ్మతి కారణాన్ని ఎంచుకుని, టెక్స్ట్‌బాక్స్‌లో వివరాలను నమోదు చేయండి.",
  },
  error_page: {
    sorry: "Sorry ",
    something_went_wrong: "Something went wrong.",
  },

  information_page: {
    info_title: "Important points to remember",
    common_points_start: [
      {
        type: "text",
        content:
          "Kindly read the important information displayed on the screen.",
      },
      {
        type: "embeddedHtml",
        content:
          "We will Dispatch your policy document with-in 7 working days from the policy issuance date. If you have opted for an e-policy, you will receive the dematerialised policy document in your e-insurance account. Aditya Birla Sun Life provides you with an online service known as My Insurance which helps you avail facilities like contact detail updation, premium payments, check fund value details etc. Kindly log onto our website <a href='www.adityabirlasunlifeinsurance.com'>www.adityabirlasunlifeinsurance.com</a> to register yourself. For detailed information, kindly go through the policy document .You can also call our toll free customer service number <a href='tel:18002707000' style={{ textDecoration: 'none' }}> 1800 270 7000 </a>",
      },
      {
        type: "text",
        content:
          "Life insurance is a standalone product and is neither a fixed deposit nor loan nor is it linked to any other banking products. Other than the policy benefits as specifically mentioned under the policy contract, there are no additional benefits under the policy. ",
      },
    ],
    ulip_points: [
      {
        type: "text",
        content:
          "ABSLI (ULIP) being purchased by you, is NOT eligible for exemption under tax at the time of payout or policy proceeds under section 10(10 D) as per the new tax norms issued under the Finance Budget 2021. As per the Finance Budget 2021, all Unit Linked Insurance policies newly purchased on or after 1st Feb 2021 with an aggregate premium exceeding Rs.2,50,000/- for a given financial year , shall NOT be eligible for tax exemption under section 10 (10 D) at the time of payout (except death claim).",
      },
      {
        type: "text",
        content:
          "Being an unit linked plan, withdrawals are allowed post completion of 5 years, we however would advice you to continue paying the premium for the entire term of the product in absence of same your fund value will get impacted due to charges applicable.",
      },
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy.",
      },
      {
        type: "text",
        content:
          "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy.",
      },
    ],
    par_and_non_par_points: [
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy. We would like to inform you that except for guaranteed moneybacks/income , other pay out like bonus , maturity benefit or surrender benefit are not 100% guaranteed and is a combination of both guaranteed and non-guaranteed elements. We request you to refer the benefit illustration and policy document for more details on the this.",
      },
      {
        type: "text",
        content:
          "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer",
      },
      {
        type: "text",
        content:
          'Please note that surrendering the policy before the completion of the policy term and premium paying term i.e pre- mature surrenders like surrendering the policy before or after the start of the payout will lead to significantly lower payout than the illustrated maturity value" For additional details kindly refer the Benefit illustration". with respect to understanding lock-in period as applicable & surrender value payable before and after the start of the payout. In case of non-payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.',
      },
      {
        type: "text",
        content:
          "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document 30 days from the date of credit of your policy to e-Insurance Account.",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy.",
      },
    ],
    common_points_end: [
      {
        type: "text",
        content:
          "	Please note that surrendering the policy before the completion of the policy term and premium paying term will lead to significantly lower pay out than the illustrated maturity value. For additional details kindly refer the Benefit illustration. In case of non- payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.",
      },
      {
        type: "text",
        content:
          "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document   30 days from the date of credit of your policy to e-Insurance Account.",
      },
    ],
  },
  landing_page: {
    start: "ప్రారంభించండి",
    hi: "Hi ",
    heading_1a: "ఆదిత్య బిర్లా సన్ లైఫ్ ఇన్సూరెన్స్ ఫ్యామిలీకి స్వాగతం",
    heading_1b: "మీ అప్లికేషన్ నంబర్",
  },
  personal_detail_page: {
    personal_title: "వ్యక్తిగత సమాచారం",
    application_number: "దరఖాస్తు సంఖ్య",
    policy_number: "పాలసీ యజమాని",
    owner_DOB: "యజమాని DOB",
    life_insured: "జీవిత బీమా చేయబడింది",
    insured_DOB: "బీమా చేయబడిన DOB",
    nominee_name: "నామినీ పేరు",
    income: "యజమాని ఆదాయం",
    occupation: "యజమాని వృత్తి",
    email: "ఇమెయిల్ ఇది",
    contact_number: "సంప్రదింపు నంబర్",
    address: "చిరునామా",
    city_state: "నగరం/రాష్ట్రం",
    pinCode: "పిన్ కోడ్",
    hdfcCheckBox:
      "నా బీమా ప్రతిపాదనను వేగంగా ప్రాసెస్ చేయడం కోసం నేను HDFC బ్యాంక్‌కి ఫోన్ నంబర్, ఇ-మెయిల్ ID, చిరునామా, నగదు రహిత క్రెడిట్, ప్రొఫైల్ మొదలైన నా వ్యక్తిగత సమాచారాన్ని బీమా కంపెనీతో పంచుకోవడానికి ఇందుమూలంగా సమ్మతిస్తున్నాను. ఈ బీమాను కొనుగోలు చేసేటప్పుడు ఏ ఇతర బ్యాంకింగ్ ఉత్పత్తి/సేవ కోసం సేల్స్ రిప్రజెంటేటివ్ ఎటువంటి వాగ్దానం చేయలేదని నేను దీని ద్వారా ధృవీకరిస్తున్నాను.",
    info: 'స్క్రీన్‌పై ప్రదర్శించబడే మొత్తం సమాచారం సరైనదైతే, దయచేసి "అంగీకరించు"పై క్లిక్ చేయండి, లేకుంటే "అసమ్మతి" క్లిక్ చేయండి',
  },
  photo_proof_page: {
    confirmation: "Confirmation",
    subTitle_1a: "You confirm that the ",
    subTitle_1b: " Details given in the previous page are correct.",
    subTitle_2: "Please click on the Capture button to capture photo.",
    personal: "Personal",
    policy: "Policy",
  },
  policy_detail_page: {
    policy_title: "పాలసీ వివరాలు",
    plan_name: "ప్లాన్ పేరు",
    payment: "చెల్లింపు ఫ్రీక్వెన్సీ",
    policy_term: "పాలసీ టర్మ్",
    years: " సంవత్సరాలు",
    premium_payment: "ప్రీమియం చెల్లింపు వ్యవధి",
    premium_amount: "ప్రీమియం మొత్తం",
    sum_assured: "హామీ మొత్తం",
    purpose_of_insurance: "బీమా ప్రయోజనం",
    application_no: "దరఖాస్తు సంఖ్య",
    plan_type: "ప్రణాళిక రకం",
    info: 'స్క్రీన్‌పై ప్రదర్శించబడే మొత్తం సమాచారం సరైనదైతే, దయచేసి "అంగీకరించు"పై క్లిక్ చేయండి, లేకుంటే "అసమ్మతి" క్లిక్ చేయండి',
  },
  thank_you_page: {
    thank_you_title: "Thank You",
    message1:
      "for your valuable time, your sales representative will get in touch with you shortly",
    message2:
      "for your valuable time. We appreciate your decision for choosing Aditya Birla Sun Life Insurance as your preferred life insurer.",
    message3: "Your application number is ",
  },
  verification_page: {
    verification_title: "ధృవీకరణ",
    verification_sub_title: "దయచేసి దిగువ వివరాలను నమోదు చేయండి",
    verify_dob: "జీవిత బీమా చేసిన వ్యక్తి పుట్టిన తేదీ",
    verify_phone: "ప్రపోజర్ యొక్క ఫోన్ నంబర్",
    language: "భాష",
    otp_title: "మీ నంబర్‌కు పంపిన OTPని నమోదు చేయండి",
    otp_placeHolder: "OTP",
    seconds_left: " seconds left..",
    errorMsg1: "మీరు అన్ని ప్రయత్నాలను అధిగమించారు. దయచేసి తిరిగి కాల్ చేయండి",
    errorMsg2: "ఏదో తప్పు జరిగింది, దయచేసి మళ్లీ ప్రయత్నించండి.",
    errorMsg12: "మరియు సరైన వివరాలను నమోదు చేయండి.",
    incorrectMsg: "సరికాని OTP. దయచేసి మళ్లీ ప్రయత్నించండి.",
    sendOtpAgain: "OTP మళ్లీ పంపబడింది.",
    wrongDate: "నమోదు చేసిన పుట్టిన తేదీ తప్పు. దయచేసి మళ్లీ ప్రయత్నించండి.",
    wrongPhone: "నమోదు చేసిన ఫోన్ తప్పు. దయచేసి మళ్లీ ప్రయత్నించండి.",
    wrongLanguage: "ఎంచుకున్న భాష తప్పు. దయచేసి మళ్లీ ప్రయత్నించండి.",
    otp_disclaimer: "రిజిస్టర్డ్ మొబైల్ నంబర్‌కు OTP పంపబడుతుంది",
  },
  video_proof_page: {
    video_title: "Video Undertaking",
    detail_1: "Please Click on record button and read out the below Text",
    detail_2_a: "I ",
    detail_2_b: ", hereby confirm that I have understood the details of",
    detail_3:
      " and agree to terms and conditions explained to me. I hereby agree to process my application. My mobile number is ",
    recordFailure:
      "Sorry, the video wasn't uploaded successfully. Please click on the submit button to upload again.",
    permissionMsg: "Video Permission denied, please give permission for video",
    record_again: "Please record again",
  },
  photo_dialog_page: { confirm_title: "Confirm the picture taken" },
  buttons: {
    initiate_recorder: "Initiate Recorder",
    retake: "Retake",
    confirm: "Confirm",
    stop: "Stop",
    next: "తరువాత",
    back: "వెనుకకు",
    submit: "Submit",
    resend: "Resend",
    agree: "అంగీకరిస్తున్నారు",
    disagree: "అంగీకరించలేదు",
    capture: "Capture",
    record: "Record",
    re_record: "Re-record",
    verify: "Verify",
  },
};

export const KannadaLanguageContent = {
  flowComplete: "You have already Completed the process",
  disagree_page: {
    disagree_title: "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಭಿನ್ನಾಭಿಪ್ರಾಯಕ್ಕೆ ಕಾರಣವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    remarks: "ಟೀಕೆಗಳು",
    please_enter_remarks: "ದಯವಿಟ್ಟು ಟೀಕೆಗಳನ್ನು ನಮೂದಿಸಿ",
    personal_title: "Personal Details Disagree",
    policy_title: "Policy Details Disagree",
    reason:
      "ದಯವಿಟ್ಟು ಭಿನ್ನಾಭಿಪ್ರಾಯದ ಕಾರಣವನ್ನು ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ಪಠ್ಯ ಪೆಟ್ಟಿಗೆಯಲ್ಲಿ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ.",
  },
  error_page: {
    sorry: "Sorry ",
    something_went_wrong: "Something went wrong.",
  },

  information_page: {
    info_title: "Important points to remember",
    common_points_start: [
      {
        type: "text",
        content:
          "Kindly read the important information displayed on the screen.",
      },
      {
        type: "embeddedHtml",
        content:
          "We will Dispatch your policy document with-in 7 working days from the policy issuance date. If you have opted for an e-policy, you will receive the dematerialised policy document in your e-insurance account. Aditya Birla Sun Life provides you with an online service known as My Insurance which helps you avail facilities like contact detail updation, premium payments, check fund value details etc. Kindly log onto our website <a href='www.adityabirlasunlifeinsurance.com'>www.adityabirlasunlifeinsurance.com</a> to register yourself. For detailed information, kindly go through the policy document .You can also call our toll free customer service number <a href='tel:18002707000' style={{ textDecoration: 'none' }}> 1800 270 7000 </a>",
      },
      {
        type: "text",
        content:
          "Life insurance is a standalone product and is neither a fixed deposit nor loan nor is it linked to any other banking products. Other than the policy benefits as specifically mentioned under the policy contract, there are no additional benefits under the policy. ",
      },
    ],
    ulip_points: [
      {
        type: "text",
        content:
          "ABSLI (ULIP) being purchased by you, is NOT eligible for exemption under tax at the time of payout or policy proceeds under section 10(10 D) as per the new tax norms issued under the Finance Budget 2021. As per the Finance Budget 2021, all Unit Linked Insurance policies newly purchased on or after 1st Feb 2021 with an aggregate premium exceeding Rs.2,50,000/- for a given financial year , shall NOT be eligible for tax exemption under section 10 (10 D) at the time of payout (except death claim).",
      },
      {
        type: "text",
        content:
          "Being an unit linked plan, withdrawals are allowed post completion of 5 years, we however would advice you to continue paying the premium for the entire term of the product in absence of same your fund value will get impacted due to charges applicable.",
      },
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy.",
      },
      {
        type: "text",
        content:
          "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy.",
      },
    ],
    par_and_non_par_points: [
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy. We would like to inform you that except for guaranteed moneybacks/income , other pay out like bonus , maturity benefit or surrender benefit are not 100% guaranteed and is a combination of both guaranteed and non-guaranteed elements. We request you to refer the benefit illustration and policy document for more details on the this.",
      },
      {
        type: "text",
        content:
          "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer",
      },
      {
        type: "text",
        content:
          'Please note that surrendering the policy before the completion of the policy term and premium paying term i.e pre- mature surrenders like surrendering the policy before or after the start of the payout will lead to significantly lower payout than the illustrated maturity value" For additional details kindly refer the Benefit illustration". with respect to understanding lock-in period as applicable & surrender value payable before and after the start of the payout. In case of non-payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.',
      },
      {
        type: "text",
        content:
          "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document 30 days from the date of credit of your policy to e-Insurance Account.",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy.",
      },
    ],
    common_points_end: [
      {
        type: "text",
        content:
          "	Please note that surrendering the policy before the completion of the policy term and premium paying term will lead to significantly lower pay out than the illustrated maturity value. For additional details kindly refer the Benefit illustration. In case of non- payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.",
      },
      {
        type: "text",
        content:
          "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document   30 days from the date of credit of your policy to e-Insurance Account.",
      },
    ],
  },
  landing_page: {
    start: "Start",
    hi: "Hi ",
    heading_1a: "ಆದಿತ್ಯ ಬಿರ್ಲಾ ಸನ್ ಲೈಫ್ ಇನ್ಶುರೆನ್ಸ್ ಕುಟುಂಬಕ್ಕೆ ಸುಸ್ವಾಗತ",
    heading_1b: "ನಿಮ್ಮ ಅರ್ಜಿ ಸಂಖ್ಯೆ",
  },
  personal_detail_page: {
    personal_title: "ವೈಯಕ್ತಿಕ ವಿವರಗಳು",
    application_number: "ಅಪ್ಲಿಕೇಶನ್ ಸಂಖ್ಯೆ",
    policy_number: "ನೀತಿ ಮಾಲೀಕರು",
    owner_DOB: "ಮಾಲೀಕರು DOB",
    life_insured: "ಜೀವ ವಿಮೆ ಮಾಡಿಸಲಾಗಿದೆ",
    insured_DOB: "ವಿಮೆ ಮಾಡಲಾದ DOB",
    nominee_name: "ನಾಮಿನಿ ಹೆಸರು",
    income: "ಮಾಲೀಕರ ಆದಾಯ",
    occupation: "ಮಾಲೀಕರ ಉದ್ಯೋಗ",
    email: "ಇಮೇಲ್ ಈದ್",
    contact_number: "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
    address: "ವಿಳಾಸ",
    city_state: "ನಗರ/ರಾಜ್ಯ",
    pinCode: "ಪಿನ್‌ಕೋಡ್",
    hdfcCheckBox:
      "ನನ್ನ ವಿಮಾ ಪ್ರಸ್ತಾವನೆಯನ್ನು ವೇಗವಾಗಿ ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲು ಅನುಕೂಲವಾಗುವಂತೆ ವಿಮಾ ಕಂಪನಿಯೊಂದಿಗೆ ಫೋನ್ ಸಂಖ್ಯೆ, ಇ-ಮೇಲ್ ಐಡಿ, ವಿಳಾಸ, ನಗದುರಹಿತ ಕ್ರೆಡಿಟ್, ಪ್ರೊಫೈಲ್, ಇತ್ಯಾದಿಗಳಂತಹ ನನ್ನ ವೈಯಕ್ತಿಕ ಮಾಹಿತಿಯನ್ನು ಹಂಚಿಕೊಳ್ಳಲು ನಾನು HDFC ಬ್ಯಾಂಕ್‌ಗೆ ಈ ಮೂಲಕ ಸಮ್ಮತಿಸುತ್ತೇನೆ. ಈ ವಿಮೆಯನ್ನು ಖರೀದಿಸುವಾಗ ಯಾವುದೇ ಇತರ ಬ್ಯಾಂಕಿಂಗ್ ಉತ್ಪನ್ನ/ಸೇವೆಗಾಗಿ ಮಾರಾಟ ಪ್ರತಿನಿಧಿಯು ಯಾವುದೇ ಭರವಸೆಯನ್ನು ನೀಡಿಲ್ಲ ಎಂದು ನಾನು ಈ ಮೂಲಕ ದೃಢೀಕರಿಸುತ್ತೇನೆ.",
    info: 'ಪರದೆಯ ಮೇಲೆ ಪ್ರದರ್ಶಿಸಲಾದ ಎಲ್ಲಾ ಮಾಹಿತಿಯು ಸರಿಯಾಗಿದ್ದರೆ, ದಯವಿಟ್ಟು "ಸಮ್ಮತಿಸು" ಕ್ಲಿಕ್ ಮಾಡಿ ಇಲ್ಲದಿದ್ದರೆ "ಅಸಮ್ಮತಿ" ಕ್ಲಿಕ್ ಮಾಡಿ',
  },
  photo_proof_page: {
    confirmation: "Confirmation",
    subTitle_1a: "You confirm that the ",
    subTitle_1b: " Details given in the previous page are correct.",
    subTitle_2: "Please click on the Capture button to capture photo.",
    personal: "Personal",
    policy: "Policy",
  },
  policy_detail_page: {
    policy_title: "ನೀತಿ ವಿವರಗಳು",
    plan_name: "ಯೋಜನೆಯ ಹೆಸರು",
    payment: "ಪಾವತಿ ಆವರ್ತನ",
    policy_term: "ನೀತಿ ಅವಧಿ",
    years: " ವರ್ಷಗಳು",
    premium_payment: "ಪ್ರೀಮಿಯಂ ಪಾವತಿ ಅವಧಿ",
    premium_amount: "ಪ್ರೀಮಿಯಂ ಮೊತ್ತ",
    sum_assured: "ವಿಮಾ ಮೊತ್ತ",
    purpose_of_insurance: "ವಿಮೆಯ ಉದ್ದೇಶ",
    application_no: "ಅಪ್ಲಿಕೇಶನ್ ಸಂಖ್ಯೆ",
    plan_type: "ಯೋಜನೆ ಪ್ರಕಾರ",
    info: 'ಪರದೆಯ ಮೇಲೆ ಪ್ರದರ್ಶಿಸಲಾದ ಎಲ್ಲಾ ಮಾಹಿತಿಯು ಸರಿಯಾಗಿದ್ದರೆ, ದಯವಿಟ್ಟು "ಸಮ್ಮತಿಸು" ಕ್ಲಿಕ್ ಮಾಡಿ ಇಲ್ಲದಿದ್ದರೆ "ಅಸಮ್ಮತಿ" ಕ್ಲಿಕ್ ಮಾಡಿ',
  },
  thank_you_page: {
    thank_you_title: "Thank You",
    message1:
      "for your valuable time, your sales representative will get in touch with you shortly",
    message2:
      "for your valuable time. We appreciate your decision for choosing Aditya Birla Sun Life Insurance as your preferred life insurer.",
    message3: "Your application number is ",
  },
  verification_page: {
    verification_title: "ಪರಿಶೀಲನೆ",
    verification_sub_title: "ದಯವಿಟ್ಟು ಕೆಳಗಿನ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    verify_dob: "ಜೀವ ವಿಮೆದಾರರ ಜನ್ಮ ದಿನಾಂಕ",
    verify_phone: "ಪ್ರಸ್ತಾಪಿಸುವವರ ಫೋನ್ ಸಂಖ್ಯೆ",
    language: "ಭಾಷೆ",
    otp_title: "ನಿಮ್ಮ ಸಂಖ್ಯೆಗೆ ಕಳುಹಿಸಲಾದ OTP ಅನ್ನು ನಮೂದಿಸಿ",
    otp_placeHolder: "OTP",
    seconds_left: " seconds left..",
    errorMsg1: "ನೀವು ಎಲ್ಲಾ ಪ್ರಯತ್ನಗಳನ್ನು ಮೀರಿದ್ದೀರಿ. ದಯವಿಟ್ಟು ಮರಳಿ ಕರೆ ಮಾಡಿ",
    errorMsg2: "ಏನೋ ತಪ್ಪಾಗಿದೆ, ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    errorMsg12: " ಮತ್ತು ಸರಿಯಾದ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ.",
    incorrectMsg: "ತಪ್ಪಾದ OTP. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
    sendOtpAgain: "ಮತ್ತೆ OTP ಕಳುಹಿಸಲಾಗಿದೆ.",
    wrongDate: "ನಮೂದಿಸಿದ ಜನ್ಮ ದಿನಾಂಕ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
    wrongPhone: "ನಮೂದಿಸಿದ ಫೋನ್ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
    wrongLanguage: "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಪುನಃ ಪ್ರಯತ್ನಿಸಿ.",
    otp_disclaimer: "ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ OTP ಕಳುಹಿಸಲಾಗುತ್ತದೆ",
  },
  video_proof_page: {
    video_title: "Video Undertaking",
    detail_1: "Please Click on record button and read out the below Text",
    detail_2_a: "I ",
    detail_2_b: ", hereby confirm that I have understood the details of",
    detail_3:
      " and agree to terms and conditions explained to me. I hereby agree to process my application. My mobile number is ",
    recordFailure:
      "Sorry, the video wasn't uploaded successfully. Please click on the submit button to upload again.",
    permissionMsg: "Video Permission denied, please give permission for video",
    record_again: "Please record again",
  },
  photo_dialog_page: { confirm_title: "Confirm the picture taken" },
  buttons: {
    initiate_recorder: "Initiate Recorder",
    retake: "Retake",
    confirm: "Confirm",
    stop: "Stop",
    next: "ಮುಂದೆ",
    back: "ಹಿಂದೆ",
    submit: "Submit",
    resend: "Resend",
    agree: "ಒಪ್ಪುತ್ತೇನೆ",
    disagree: "ಒಪ್ಪುವುದಿಲ್ಲ",
    capture: "Capture",
    record: "Record",
    re_record: "Re-record",
    verify: "Verify",
  },
};

export const BengaliLanguageContent = {
  flowComplete: "আপনি ইতিমধ্যে প্রক্রিয়া সম্পন্ন করেছেন",
  disagree_page: {
    disagree_title: "অনুগ্রহ করে আপনার মতবিরোধের কারণ(গুলি) বেছে নিন",
    remarks: "মন্তব্য",
    please_enter_remarks: "মন্তব্য লিখুন",
    personal_title: "ব্যক্তিগত বিবরণ অসম্মত",
    policy_title: "নীতির বিবরণ অসম্মত",
    reason:
      "Please select the reason of disagreement and enter the details in the textbox.",
  },
  error_page: {
    sorry: "Sorry ",
    something_went_wrong: "Something went wrong.",
  },
  information_page: {
    info_title: "Important points to remember",
    common_points_start: [
      {
        type: "text",
        content:
          "Kindly read the important information displayed on the screen.",
      },
      {
        type: "embeddedHtml",
        content:
          "We will Dispatch your policy document with-in 7 working days from the policy issuance date. If you have opted for an e-policy, you will receive the dematerialised policy document in your e-insurance account. Aditya Birla Sun Life provides you with an online service known as My Insurance which helps you avail facilities like contact detail updation, premium payments, check fund value details etc. Kindly log onto our website <a href='www.adityabirlasunlifeinsurance.com'>www.adityabirlasunlifeinsurance.com</a> to register yourself. For detailed information, kindly go through the policy document .You can also call our toll free customer service number <a href='tel:18002707000' style={{ textDecoration: 'none' }}> 1800 270 7000 </a>",
      },
      {
        type: "text",
        content:
          "Life insurance is a standalone product and is neither a fixed deposit nor loan nor is it linked to any other banking products. Other than the policy benefits as specifically mentioned under the policy contract, there are no additional benefits under the policy. ",
      },
    ],
    ulip_points: [
      {
        type: "text",
        content:
          "ABSLI (ULIP) being purchased by you, is NOT eligible for exemption under tax at the time of payout or policy proceeds under section 10(10 D) as per the new tax norms issued under the Finance Budget 2021. As per the Finance Budget 2021, all Unit Linked Insurance policies newly purchased on or after 1st Feb 2021 with an aggregate premium exceeding Rs.2,50,000/- for a given financial year , shall NOT be eligible for tax exemption under section 10 (10 D) at the time of payout (except death claim).",
      },
      {
        type: "text",
        content:
          "Being an unit linked plan, withdrawals are allowed post completion of 5 years, we however would advice you to continue paying the premium for the entire term of the product in absence of same your fund value will get impacted due to charges applicable.",
      },
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy.",
      },
      {
        type: "text",
        content:
          "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy.",
      },
    ],
    par_and_non_par_points: [
      {
        type: "text",
        content:
          "We request you to continue paying the premium for the entire term to enjoy the benefits of the policy. We would like to inform you that except for guaranteed moneybacks/income , other pay out like bonus , maturity benefit or surrender benefit are not 100% guaranteed and is a combination of both guaranteed and non-guaranteed elements. We request you to refer the benefit illustration and policy document for more details on the this.",
      },
      {
        type: "text",
        content:
          "As per recent changes in section 10 (10D) of Income Tax Act, where the amount of aggregate annual premium payable in the financial year in case of Traditional plans (all non-unit linked plans except Annuity, Pension and Pure risk Plans) issued on or after 1st April, 2023 exceeding INR 5,00,000 the benefits of the policy/policies shall not be eligible for exemption under section 10 (10D) except in case of death'. The customer is requested to seek advice of a tax advisor with respect to his/her personal tax liabilities under the Income Tax Law or Foreign jurisdictions in case of Non-Resident customer",
      },
      {
        type: "text",
        content:
          'Please note that surrendering the policy before the completion of the policy term and premium paying term i.e pre- mature surrenders like surrendering the policy before or after the start of the payout will lead to significantly lower payout than the illustrated maturity value" For additional details kindly refer the Benefit illustration". with respect to understanding lock-in period as applicable & surrender value payable before and after the start of the payout. In case of non-payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.',
      },
      {
        type: "text",
        content:
          "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document 30 days from the date of credit of your policy to e-Insurance Account.",
      },
      {
        type: "checkbox",
        content:
          "I hereby confirm that, I have declared all the Pre-existing policy details availed by me in the past on the application form while applying for this policy.",
      },
    ],
    common_points_end: [
      {
        type: "text",
        content:
          "Please note that surrendering the policy before the completion of the policy term and premium paying term will lead to significantly lower pay out than the illustrated maturity value. For additional details kindly refer the Benefit illustration. In case of non-payment of premiums towards the primary policy, the Rider benefit shall also cease to exist.",
      },
      {
        type: "text",
        content:
          "We will now proceed for policy conversion which is subject to any pending requirements being fulfilled. If you are not satisfied with the terms of the policy or require any alteration, you have an option to get back to us within free look period, where the Freelook period in your policy is 15 days from receipt of your physical policy document 30 days from the date of credit of your policy to e-Insurance Account.",
      },
    ],
  },
  landing_page: {
    start: "Start",
    hi: "Hi ",
    heading_1a: "Welcome to Aditya Birla Sun Life Insurance Family ",
    heading_1b: "Your application number is ",
  },
  personal_detail_page: {
    personal_title: "Personal Details",
    application_number: "Application Number",
    policy_number: "Policy Owner",
    owner_DOB: "Owner DOB",
    life_insured: "Life Insured",
    insured_DOB: "Insured DOB",
    nominee_name: "Nominee Name",
    income: "Owner Income",
    occupation: "Owner Occupation",
    email: "Email ID",
    contact_number: "Contact Number",
    address: "Address",
    city_state: "City/State",
    pinCode: "Pincode",
    hdfcCheckBox:
      "I hereby consent to HDFC Bank to share my personal information like phone number, e-mail ID, address, Non-Cash Credit, profile, etc. with the insurance company in order to facilitate faster processing of my insurance proposal. I hereby confirm No promise was made by the sales representative for any other banking product /service while buying this insurance.",
    info: 'If all information displayed on the screen is correct, Please click on "Agree" else click "Disagree"',
  },
  photo_proof_page: {
    confirmation: "Confirmation",
    subTitle_1a: "You confirm that the ",
    subTitle_1b: " Details given in the previous page are correct.",
    subTitle_2: "Please click on the Capture button to capture photo.",
    personal: "Personal",
    policy: "Policy",
  },
  policy_detail_page: {
    policy_title: "Policy Details",
    plan_name: "Plan Name",
    payment: "Payment Frequency",
    policy_term: "Policy Term",
    years: " years",
    premium_payment: "Premium Payment Term",
    premium_amount: "Premium Amount",
    sum_assured: "Sum Assured",
    purpose_of_insurance: "Purpose of Insurance",
    application_no: "Application Number",
    plan_type: "Plan Type",
    info: 'If all information displayed on the screen is correct, Please click on "Agree" else click "Disagree"',
  },
  thank_you_page: {
    thank_you_title: "Thank You",
    message1:
      "for your valuable time, your sales representative will get in touch with you shortly",
    message2:
      "for your valuable time. We appreciate your decision for choosing Aditya Birla Sun Life Insurance as your preferred life insurer.",
    message3: "Your application number is ",
  },
  verification_page: {
    verification_title: "Verification",
    verification_sub_title: "Please enter the below details",
    verify_dob: "Date of Birth of the life insured",
    verify_phone: "Phone Number of the proposer",
    language: "Language",
    otp_title: "Enter the OTP sent on your number",
    otp_placeHolder: "OTP",
    seconds_left: " seconds left..",
    errorMsg1: "you have exceeded all the attempts. Please call back on ",
    errorMsg2: "Something went wrong,Please try again.",
    errorMsg12: " and enter the correct details.",
    incorrectMsg: "Incorrect OTP. Please try again.",
    sendOtpAgain: "OTP has been sent again.",
    wrongDate: "The Date of Birth entered is incorrect. Please try again.",
    wrongPhone: "The Phone entered is incorrect. Please try again.",
    wrongLanguage: "The language selected is incorrect. Please try again.",
    otp_disclaimer: "OTP will be sent on the registered mobile number",
  },
  video_proof_page: {
    video_title: "Video Undertaking",
    detail_1: "Please Click on record button and read out the below Text",
    detail_2_a: "I ",
    detail_2_b: ", hereby confirm that I have understood the details of",
    detail_3:
      " and agree to terms and conditions explained to me. I hereby agree to process my application. My mobile number is ",
    recordFailure:
      "Sorry, the video wasn't uploaded successfully. Please click on the submit button to upload again.",
    permissionMsg: "Video Permission denied, please give permission for video",
    record_again: "Please record again",
  },
  photo_dialog_page: { confirm_title: "Confirm the picture taken" },
  buttons: {
    initiate_recorder: "Initiate Recorder",
    retake: "Retake",
    confirm: "Confirm",
    stop: "Stop",
    next: "Next",
    back: "Back",
    submit: "Submit",
    resend: "Resend",
    agree: "Agree",
    disagree: "Disagree",
    capture: "Capture",
    record: "Record",
    re_record: "Re-record",
    verify: "Verify",
  },
};

export const MarathiLanguageContent = {
  flowComplete: "तुम्ही आधीच प्रक्रिया पूर्ण केली आहे",
  disagree_page: {
    disagree_title: "कृपया तुमच्या असहमतीचे कारण निवडा",
    remarks: "टिप्पण्या",
    please_enter_remarks: "कृपया टिप्पण्या प्रविष्ट करा",
    personal_title: "वैयक्तिक तपशील असहमत",
    policy_title: "धोरण तपशील असहमत",
    reason:
      "कृपया असहमतीचे कारण निवडा आणि मजकूर बॉक्समध्ये तपशील प्रविष्ट करा.",
  },
  error_page: {
    sorry: "क्षमस्व ",
    something_went_wrong: "काहीतरी चूक झाली.",
  },
  information_page: {
    info_title: "लक्षात ठेवण्यासाठी महत्वाचे मुद्दे",
    common_points_start: [
      {
        type: "text",
        content: "कृपया स्क्रीनवर दिसणारी महत्त्वाची माहिती वाचा.",
      },
      {
        type: "embeddedHtml",
        content:
          "आम्ही पॉलिसी जारी करण्याच्या तारखेपासून 7 कामकाजाच्या दिवसांत तुमचे पॉलिसी दस्तऐवज पाठवू. जर तुम्ही ई-पॉलिसी निवडली असेल, तर तुम्हाला तुमच्या ई-विमा खात्यामध्ये डीमटेरिअलाइज्ड पॉलिसी दस्तऐवज प्राप्त होईल. आदित्य बिर्ला सन लाइफ तुम्हाला माय इन्शुरन्स नावाने ओळखली जाणारी ऑनलाइन सेवा पुरवते जी तुम्हाला संपर्क तपशील अपडेट, प्रीमियम पेमेंट, चेक फंड मूल्य तपशील इत्यादी सुविधा मिळविण्यात मदत करते. कृपया आमच्या वेबसाइटवर लॉग इन करा.<a href='www.adityabirlasunlifeinsurance.com'>www.adityabirlasunlifeinsurance.com</a> स्वतःची नोंदणी करण्यासाठी. तपशीलवार माहितीसाठी, कृपया पॉलिसी दस्तऐवज पहा. तुम्ही आमच्या टोल फ्री ग्राहक सेवा क्रमांकावर देखील कॉल करू शकता<a href='tel:18002707000' style={{ textDecoration: 'none' }}> 1800 270 7000 </a>",
      },
      {
        type: "text",
        content:
          "जीवन विमा हे एक स्वतंत्र उत्पादन आहे आणि ते फिक्स डिपॉझिट किंवा कर्ज नाही किंवा ते इतर कोणत्याही बँकिंग उत्पादनांशी जोडलेले नाही. पॉलिसी कॉन्ट्रॅक्ट अंतर्गत विशेषत: नमूद केलेल्या पॉलिसी फायद्यांव्यतिरिक्त, कोणतेही अतिरिक्त फायदे नाहीत. ",
      },
    ],
    ulip_points: [
      {
        type: "text",
        content:
          "तुमच्याद्वारे खरेदी केलेले ABSLI (ULIP) हे वित्त अर्थसंकल्प २०२१ अंतर्गत जारी केलेल्या नवीन कर नियमांनुसार पेआउट किंवा पॉलिसीच्या उत्पन्नाच्या वेळी करांतर्गत सवलत मिळण्यास पात्र नाही. वित्त बजेट २०२१ नुसार , 1 फेब्रुवारी 2021 रोजी किंवा त्यानंतर नवीन खरेदी केलेल्या सर्व युनिट लिंक्ड विमा पॉलिसी दिलेल्या आर्थिक वर्षासाठी रु. 2,50,000/- पेक्षा जास्त एकूण प्रीमियमसह, त्या वेळी कलम 10 (10 डी) अंतर्गत कर सूट मिळण्यास पात्र नसतील. पेआउट (मृत्यूचा दावा वगळता).",
      },
      {
        type: "text",
        content:
          "एक युनिट लिंक्ड प्लॅन असल्याने, 5 वर्षे पूर्ण झाल्यानंतर पैसे काढण्याची परवानगी आहे, तथापि आम्ही तुम्हाला उत्पादनाच्या संपूर्ण कालावधीसाठी प्रीमियम भरणे सुरू ठेवण्याचा सल्ला देऊ, असे नसताना तुमच्या फंड मूल्यावर लागू शुल्कामुळे परिणाम होईल.",
      },
      {
        type: "text",
        content:
          "पॉलिसीच्या फायद्यांचा आनंद घेण्यासाठी आम्ही तुम्हाला संपूर्ण मुदतीसाठी प्रीमियम भरणे सुरू ठेवण्याची विनंती करतो.",
      },
      {
        type: "text",
        content:
          "प्राप्तिकर कायद्याच्या कलम 10 (10D) मधील अलीकडील बदलांनुसार, जेथे पारंपारिक योजना (वार्षिक, पेन्शन आणि शुद्ध जोखीम योजना वगळता सर्व नॉन-युनिट लिंक्ड प्लॅन्स) च्या बाबतीत आर्थिक वर्षात देय असलेल्या एकूण वार्षिक प्रीमियमची रक्कम किंवा 1 एप्रिल, 2023 नंतर INR 5,00,000 पेक्षा जास्त पॉलिसी/पॉलिसींचे फायदे कलम 10 (10D) अंतर्गत मृत्यूच्या बाबतीत सूट मिळण्यास पात्र नसतील'. अनिवासी ग्राहकाच्या बाबतीत आयकर कायद्यांतर्गत किंवा परदेशी अधिकार क्षेत्रांतर्गत त्याच्या/तिच्या वैयक्तिक कर दायित्वांच्या संदर्भात ग्राहकाला कर सल्लागाराचा सल्ला घेण्याची विनंती केली जाते.",
      },
      {
        type: "checkbox",
        content:
          "मी याद्वारे पुष्टी करतो की या पॉलिसीसाठी अर्ज करताना मी पूर्वी उपलब्ध असलेले सर्व पॉलिसी तपशील अर्ज फॉर्मवर घोषित केले आहेत.",
      },
    ],
    par_and_non_par_points: [
      {
        type: "text",
        content:
          "पॉलिसीच्या फायद्यांचा आनंद घेण्यासाठी आम्ही तुम्हाला संपूर्ण मुदतीसाठी प्रीमियम भरणे सुरू ठेवण्याची विनंती करतो. आम्‍ही तुम्‍हाला कळवू इच्‍छितो की गॅरंटीड मनीबॅक/उत्पन्न वगळता, बोनस, मॅच्युरिटी बेनिफिट किंवा सरेंडर बेनिफिट यांसारखे इतर पे आऊट 100% गॅरंटीड नसतात आणि ते गॅरंटीड आणि नॉन-गॅरंटीड अशा दोन्ही घटकांचे मिश्रण असते. याबद्दल अधिक तपशीलांसाठी आम्ही तुम्हाला लाभाचे उदाहरण आणि पॉलिसी दस्तऐवज पाहण्याची विनंती करतो.",
      },
      {
        type: "text",
        content:
          "प्राप्तिकर कायद्याच्या कलम 10 (10D) मधील अलीकडील बदलांनुसार, जेथे पारंपारिक योजना (वार्षिक, पेन्शन आणि शुद्ध जोखीम योजना वगळता सर्व नॉन-युनिट लिंक्ड प्लॅन्स) च्या बाबतीत आर्थिक वर्षात देय असलेल्या एकूण वार्षिक प्रीमियमची रक्कम किंवा 1 एप्रिल, 2023 नंतर INR 5,00,000 पेक्षा जास्त पॉलिसी/पॉलिसींचे फायदे कलम 10 (10D) अंतर्गत मृत्यूच्या बाबतीत सूट मिळण्यास पात्र नसतील'. अनिवासी ग्राहकाच्या बाबतीत आयकर कायद्यांतर्गत किंवा परदेशी अधिकार क्षेत्रांतर्गत त्याच्या/तिच्या वैयक्तिक कर दायित्वांच्या संदर्भात ग्राहकाने कर सल्लागाराचा सल्ला घ्यावा अशी विनंती केली जाते.",
      },
      {
        type: "text",
        content:
          'कृपया लक्षात घ्या की पॉलिसीची मुदत आणि प्रीमियम भरण्याची मुदत पूर्ण होण्यापूर्वी पॉलिसी समर्पण करणे, जसे की पेआउट सुरू होण्यापूर्वी किंवा नंतर पॉलिसी समर्पण करणे, सचित्र मॅच्युरिटी मूल्यापेक्षा लक्षणीयरीत्या कमी पेआउट होईल" अतिरिक्त तपशीलांसाठी कृपया लाभाचे उदाहरण पहा. लॉक-इन कालावधी लागू आणि पेआउट सुरू होण्यापूर्वी आणि नंतर देय समर्पण मूल्य समजून घेण्याच्या संदर्भात. प्राथमिक पॉलिसीसाठी प्रीमियम न भरल्यास, रायडरचा लाभ देखील संपुष्टात येईल.',
      },
      {
        type: "text",
        content:
          "आम्ही आता पॉलिसी रूपांतरणासाठी पुढे जाऊ जे कोणत्याही प्रलंबित आवश्यकता पूर्ण करण्याच्या अधीन आहे. जर तुम्ही पॉलिसीच्या अटींशी समाधानी नसाल किंवा तुम्हाला कोणत्याही बदलाची आवश्यकता असेल, तर तुमच्याकडे फ्री लूक कालावधीमध्ये आमच्याकडे परत जाण्याचा पर्याय आहे, जेथे तुमच्या पॉलिसीमधील फ्रीलूक कालावधी तुमच्या फिजिकल पॉलिसी दस्तऐवजाच्या प्राप्तीपासून 30 दिवसांचा आहे. तुमच्या पॉलिसीच्या क्रेडिटच्या तारखेपासून ते ई-विमा खात्यात.",
      },
      {
        type: "checkbox",
        content:
          "मी याद्वारे पुष्टी करतो की या पॉलिसीसाठी अर्ज करताना मी पूर्वी उपलब्ध असलेले सर्व पॉलिसी तपशील अर्ज फॉर्मवर घोषित केले आहेत.",
      },
    ],
    common_points_end: [
      {
        type: "text",
        content:
          "कृपया लक्षात घ्या की पॉलिसीची मुदत आणि प्रीमियम भरण्याची मुदत पूर्ण होण्यापूर्वी पॉलिसी समर्पण केल्याने सचित्र परिपक्वता मूल्यापेक्षा लक्षणीय कमी पेआउट होईल. अतिरिक्त तपशीलांसाठी कृपया लाभाचे उदाहरण पहा. प्राथमिक पॉलिसीसाठी प्रीमियम न भरल्यास, रायडरचा लाभ देखील संपुष्टात येईल.",
      },
      {
        type: "text",
        content:
          "आम्ही आता पॉलिसी रुपांतरण पुढे चालू ठेवू जे कोणत्याही प्रलंबित आवश्यकता पूर्ण करण्याच्या अधीन आहे. जर तुम्ही पॉलिसीच्या अटींशी समाधानी नसाल किंवा तुम्हाला कोणत्याही बदलाची आवश्यकता असेल, तर तुमच्याकडे फ्री लूक कालावधीमध्ये आमच्याकडे परत येण्याचा पर्याय आहे, जेथे तुमच्या पॉलिसीमधील फ्रीलूक कालावधी तुमच्या फिजिकल पॉलिसी दस्तऐवज मिळाल्यापासून 30 दिवसांपर्यंत आहे. तुमची पॉलिसी ई-विमा खात्यात जमा झाल्याची तारीख.",
      },
    ],
  },
  landing_page: {
    start: "सुरू करा",
    hi: "नमस्कार ",
    heading_1a: "आदित्य बिर्ला सन लाइफ इन्शुरन्स कुटुंबात आपले स्वागत आहे ",
    heading_1b: "तुमचा अर्ज क्रमांक आहे",
  },
  personal_detail_page: {
    personal_title: "वैयक्तिक माहिती",
    application_number: "अर्ज क्रमांक",
    policy_number: "पॉलिसी मालक",
    owner_DOB: "मालक DOB",
    life_insured: "जीवन विमा",
    insured_DOB: "विमाधारक DOB",
    nominee_name: "नामनिर्देशित व्यक्तीचे नाव",
    income: "मालकाची मिळकत",
    occupation: "मालकाचा व्यवसाय",
    email: "ई - मेल आयडी",
    contact_number: "संपर्क क्रमांक",
    address: "पत्ता",
    city_state: "शहर/राज्य",
    pinCode: "पिन कोड",
    hdfcCheckBox:
      "माझ्या विमा प्रस्तावावर जलद प्रक्रिया करण्यासाठी मी एचडीएफसी बँकेला माझी वैयक्तिक माहिती जसे की फोन नंबर, ई-मेल आयडी, पत्ता, नॉन-कॅश क्रेडिट, प्रोफाइल इत्यादी विमा कंपनीसोबत शेअर करण्यास संमती देतो. मी याद्वारे पुष्टी करतो की हा विमा खरेदी करताना विक्री प्रतिनिधीने इतर कोणत्याही बँकिंग उत्पादन/सेवेसाठी कोणतेही वचन दिले नव्हते.",
    info: 'स्क्रीनवर प्रदर्शित केलेली सर्व माहिती योग्य असल्यास, कृपया "सहमत" वर क्लिक करा अन्यथा "असहमती" वर क्लिक करा.',
  },
  photo_proof_page: {
    confirmation: "पुष्टी",
    subTitle_1a: "तुम्ही पुष्टी करा की द ",
    subTitle_1b: " मागील पानावर दिलेला तपशील बरोबर आहे.",
    subTitle_2: "फोटो काढण्यासाठी कृपया कॅप्चर बटणावर क्लिक करा.",
    personal: "वैयक्तिक",
    policy: "धोरण",
  },
  policy_detail_page: {
    policy_title: "धोरण तपशील",
    plan_name: "योजनेचे नाव",
    payment: "पेमेंट वारंवारता",
    policy_term: "पॉलिसी टर्म",
    years: " वर्षे",
    premium_payment: "प्रीमियम पेमेंट टर्म",
    premium_amount: "प्रीमियम रक्कम",
    sum_assured: "विम्याची रक्कम",
    purpose_of_insurance: "विम्याचा उद्देश",
    application_no: "अर्ज क्रमांक",
    plan_type: "योजना प्रकार",
    info: 'स्क्रीनवर प्रदर्शित केलेली सर्व माहिती योग्य असल्यास, कृपया "सहमत" वर क्लिक करा अन्यथा "असहमती" वर क्लिक करा.',
  },
  thank_you_page: {
    thank_you_title: "धन्यवाद",
    message1:
      "तुमच्या मौल्यवान वेळेसाठी, तुमचा विक्री प्रतिनिधी लवकरच तुमच्याशी संपर्क साधेल",
    message2:
      "आपल्या मौल्यवान वेळेसाठी. आदित्य बिर्ला सन लाइफ इन्शुरन्सला तुमचा पसंतीचा जीवन विमा कंपनी म्हणून निवडल्याबद्दल आम्ही तुमच्या निर्णयाचे कौतुक करतो.",
    message3: "तुमचा अर्ज क्रमांक आहे ",
  },
  verification_page: {
    verification_title: "पडताळणी",
    verification_sub_title: "कृपया खालील तपशील प्रविष्ट करा",
    verify_dob: "विमाधारकाची जन्मतारीख",
    verify_phone: "प्रस्तावकाचा फोन नंबर",
    language: "इंग्रजी",
    otp_title: "तुमच्या नंबरवर पाठवलेला OTP टाका",
    otp_placeHolder: "OTP",
    seconds_left: " seconds left..",
    errorMsg1: "आपण सर्व प्रयत्न ओलांडले आहेत. कृपया परत कॉल करा ",
    errorMsg2: "काहीतरी चूक झाली, कृपया पुन्हा प्रयत्न करा.",
    errorMsg12: " and enter the correct details.",
    incorrectMsg: "चुकीचा OTP. कृपया पुन्हा प्रयत्न करा.",
    sendOtpAgain: "OTP पुन्हा पाठवला आहे.",
    wrongDate:
      "प्रविष्ट केलेली जन्मतारीख चुकीची आहे. कृपया पुन्हा प्रयत्न करा.",
    wrongPhone: "प्रविष्ट केलेला फोन चुकीचा आहे. कृपया पुन्हा प्रयत्न करा.",
    wrongLanguage: "निवडलेली भाषा चुकीची आहे. कृपया पुन्हा प्रयत्न करा.",
    otp_disclaimer: "नोंदणीकृत मोबाईल क्रमांकावर OTP पाठवला जाईल",
  },
  video_proof_page: {
    video_title: "व्हिडिओ उपक्रम",
    detail_1: "कृपया रेकॉर्ड बटणावर क्लिक करा आणि खालील मजकूर वाचा",
    detail_2_a: "आय ",
    detail_2_b: ", याद्वारे पुष्टी करतो की मला चे तपशील समजले आहेत",
    detail_3:
      " आणि मला समजावून सांगितलेल्या अटी व शर्तींशी सहमत आहे. मी याद्वारे माझ्या अर्जावर प्रक्रिया करण्यास सहमत आहे. माझा मोबाईल नंबर आहे ",
    recordFailure:
      "क्षमस्व, व्हिडिओ यशस्वीरित्या अपलोड झाला नाही. कृपया पुन्हा अपलोड करण्यासाठी सबमिट बटणावर क्लिक करा.",
    permissionMsg: "व्हिडिओ परवानगी नाकारली, कृपया व्हिडिओसाठी परवानगी द्या",
    record_again: "कृपया पुन्हा रेकॉर्ड करा",
  },
  photo_dialog_page: { confirm_title: "घेतलेल्या चित्राची पुष्टी करा" },
  buttons: {
    initiate_recorder: "Initiate Recorder",
    retake: "Retake",
    confirm: "Confirm",
    stop: "Stop",
    next: "Next",
    back: "Back",
    submit: "Submit",
    resend: "Resend",
    agree: "Agree",
    disagree: "Disagree",
    capture: "Capture",
    record: "Record",
    re_record: "Re-record",
    verify: "Verify",
  },
};
export const TamilLanguageContent = {
  flowComplete: "நீங்கள் ஏற்கனவே செயல்முறையை முடித்துவிட்டீர்கள்",
  disagree_page: {
    disagree_title:
      "உங்கள் கருத்து வேறுபாட்டிற்கான காரணத்தை(களை) தேர்வு செய்யவும்",
    remarks: "கருத்துக்கள்",
    please_enter_remarks: "தயவுசெய்து கருத்துகளை உள்ளிடவும்",
    personal_title: "தனிப்பட்ட விவரங்கள் உடன்படவில்லை",
    policy_title: "கொள்கை விவரங்கள் உடன்படவில்லை",
    reason:
      "கருத்து வேறுபாடுக்கான காரணத்தைத் தேர்ந்தெடுத்து உரைப்பெட்டியில் விவரங்களை உள்ளிடவும்.",
  },
  error_page: {
    sorry: "மன்னிக்கவும்",
    something_went_wrong: "ஏதோ தவறு நடந்துவிட்டது.",
  },
  information_page: {
    info_title: "நினைவில் கொள்ள வேண்டிய முக்கியமான புள்ளிகள்",
    common_points_start: [
      {
        type: "text",
        content:
          "திரையில் காட்டப்படும் முக்கியமான தகவல்களை தயவுசெய்து படிக்கவும்.",
      },
      {
        type: "embeddedHtml",
        content:
          "பாலிசி வழங்கிய தேதியிலிருந்து 7 வேலை நாட்களுக்குள் உங்கள் பாலிசி ஆவணத்தை நாங்கள் அனுப்புவோம். நீங்கள் இ-பாலிசியைத் தேர்ந்தெடுத்திருந்தால், உங்கள் இ-இன்சூரன்ஸ் கணக்கில் டிமெட்டீரியலைஸ் செய்யப்பட்ட பாலிசி ஆவணத்தைப் பெறுவீர்கள். ஆதித்யா பிர்லா சன் லைஃப் உங்களுக்கு மை இன்சூரன்ஸ் எனப்படும் ஆன்லைன் சேவையை வழங்குகிறது, இது தொடர்பு விவரம் புதுப்பித்தல், பிரீமியம் செலுத்துதல், நிதி மதிப்பு விவரங்களைச் சரிபார்த்தல் போன்ற வசதிகளைப் பெற உதவுகிறது. தயவுசெய்து எங்கள் வலைத்தளமான <a href='www.adityabirlasunlifeinsurance.com'> இல் உள்நுழையவும். உங்களைப் பதிவு செய்ய www.adityabirlasunlifeinsurance.com</a>. விரிவான தகவலுக்கு, தயவுசெய்து கொள்கை ஆவணத்தைப் பார்க்கவும் .எங்கள் கட்டணமில்லா வாடிக்கையாளர் சேவை எண்ணையும் நீங்கள் அழைக்கலாம் <a href='tel:18002707000' style={{ textDecoration: 'none' }}> 1800 270 7000 </a>",
      },
      {
        type: "text",
        content:
          "ஆயுள் காப்பீடு என்பது ஒரு தனித்த தயாரிப்பு மற்றும் நிலையான வைப்பு அல்லது கடன் அல்லது வேறு எந்த வங்கி தயாரிப்புகளுடன் இணைக்கப்படவில்லை. பாலிசி ஒப்பந்தத்தின் கீழ் குறிப்பிட்டுள்ளபடி பாலிசி நன்மைகளைத் தவிர, பாலிசியின் கீழ் கூடுதல் பலன்கள் எதுவும் இல்லை.",
      },
    ],
    ulip_points: [
      {
        type: "text",
        content:
          "நீங்கள் வாங்கும் ABSLI (ULIP) ஆனது, நிதி பட்ஜெட் 2021 இன் கீழ் வெளியிடப்பட்ட புதிய வரி விதிகளின்படி, 10(10 D) பிரிவின் கீழ் செலுத்தப்படும் அல்லது பாலிசி வருமானத்தின் போது வரியின் கீழ் விலக்கு பெறத் தகுதியற்றது. நிதி பட்ஜெட் 2021 இன் படி , கொடுக்கப்பட்ட நிதியாண்டில் ரூ.2,50,000/-க்கு மேல் மொத்த பிரீமியத்துடன் 1 பிப்ரவரி 2021 அன்று அல்லது அதற்குப் பிறகு புதிதாக வாங்கப்பட்ட அனைத்து யூனிட் இணைக்கப்பட்ட காப்பீட்டுக் கொள்கைகளும் பிரிவு 10 (10 D) இன் கீழ் வரி விலக்கு பெறத் தகுதியற்றவை. கொடுப்பனவு (மரண கோரிக்கை தவிர).",
      },
      {
        type: "text",
        content:
          "யூனிட் இணைக்கப்பட்ட திட்டமாக இருப்பதால், 5 ஆண்டுகள் முடிந்த பிறகு, திரும்பப் பெறுதல் அனுமதிக்கப்படும், இருப்பினும், பொருளின் முழு காலத்திற்கான பிரீமியத்தைத் தொடர்ந்து செலுத்துமாறு நாங்கள் உங்களுக்கு ஆலோசனை கூறுகிறோம்.",
      },
      {
        type: "text",
        content:
          "பாலிசியின் பலன்களை அனுபவிக்க முழு காலத்திற்கான பிரீமியத்தை தொடர்ந்து செலுத்துமாறு கேட்டுக்கொள்கிறோம்.",
      },
      {
        type: "text",
        content:
          "வருமான வரிச் சட்டத்தின் பிரிவு 10 (10D) இன் சமீபத்திய மாற்றங்களின்படி, பாரம்பரியத் திட்டங்களில் (ஆண்டு, ஓய்வூதியம் மற்றும் தூய ஆபத்துத் திட்டங்களைத் தவிர அனைத்து யூனிட் அல்லாத இணைக்கப்பட்ட திட்டங்களும்) நிதியாண்டில் செலுத்த வேண்டிய மொத்த வருடாந்திர பிரீமியத்தின் அளவு அல்லது ஏப்ரல் 1, 2023க்குப் பிறகு 5,00,000 ரூபாய்க்கு மேல் பாலிசி/பாலிசிகளின் பலன்கள் பிரிவு 10 (10D) இன் கீழ் மரணம் ஏற்பட்டால் தவிர விலக்கு பெறத் தகுதி பெறாது. வசிப்பவர் அல்லாத வாடிக்கையாளரின் விஷயத்தில் வருமான வரிச் சட்டம் அல்லது வெளிநாட்டு அதிகார வரம்புகளின் கீழ் அவரது தனிப்பட்ட வரி பொறுப்புகள் தொடர்பாக வரி ஆலோசகரின் ஆலோசனையைப் பெறுமாறு வாடிக்கையாளர் கேட்டுக் கொள்ளப்படுகிறார்.",
      },
      {
        type: "checkbox",
        content:
          "இந்த பாலிசிக்கு விண்ணப்பிக்கும் போது, ​​கடந்த காலத்தில் நான் பெற்ற அனைத்து பாலிசி விவரங்களையும் விண்ணப்பப் படிவத்தில் அறிவித்துள்ளேன் என்பதை உறுதி செய்கிறேன்.",
      },
    ],
    par_and_non_par_points: [
      {
        type: "text",
        content:
          "பாலிசியின் பலன்களை அனுபவிக்க முழு காலத்திற்கான பிரீமியத்தை தொடர்ந்து செலுத்துமாறு கேட்டுக்கொள்கிறோம். உத்தரவாதமான பணம்/வருமானம் தவிர, போனஸ், முதிர்வுப் பலன் அல்லது சரண்டர் பலன் போன்ற பிற கொடுப்பனவுகளுக்கு 100% உத்தரவாதம் இல்லை மற்றும் உத்தரவாதம் அளிக்கப்பட்ட மற்றும் உத்தரவாதமில்லாத கூறுகளின் கலவையாகும் என்பதை நாங்கள் உங்களுக்குத் தெரிவிக்க விரும்புகிறோம். இதைப் பற்றிய கூடுதல் விவரங்களுக்கு நன்மை விளக்கப்படம் மற்றும் கொள்கை ஆவணத்தைப் பார்க்குமாறு கேட்டுக்கொள்கிறோம்.",
      },
      {
        type: "text",
        content:
          "வருமான வரிச் சட்டத்தின் பிரிவு 10 (10D) இன் சமீபத்திய மாற்றங்களின்படி, பாரம்பரியத் திட்டங்களில் (ஆண்டு, ஓய்வூதியம் மற்றும் தூய ஆபத்துத் திட்டங்களைத் தவிர அனைத்து யூனிட் அல்லாத இணைக்கப்பட்ட திட்டங்களும்) நிதியாண்டில் செலுத்த வேண்டிய மொத்த வருடாந்திர பிரீமியத்தின் அளவு அல்லது ஏப்ரல் 1, 2023க்குப் பிறகு 5,00,000 ரூபாய்க்கு மேல் பாலிசி/பாலிசிகளின் பலன்கள் பிரிவு 10 (10D) இன் கீழ் மரணம் ஏற்பட்டால் தவிர விலக்கு பெறத் தகுதி பெறாது. வசிப்பவர் அல்லாத வாடிக்கையாளரின் விஷயத்தில் வருமான வரிச் சட்டம் அல்லது வெளிநாட்டு அதிகார வரம்புகளின் கீழ் அவரது தனிப்பட்ட வரி பொறுப்புகள் தொடர்பாக வரி ஆலோசகரின் ஆலோசனையைப் பெறுமாறு வாடிக்கையாளர் கேட்டுக் கொள்ளப்படுகிறார்.",
      },
      {
        type: "text",
        content:
          'பாலிசி கால மற்றும் பிரீமியம் செலுத்தும் காலத்தை முடிப்பதற்கு முன் பாலிசியை சரணடைவது, அதாவது பேஅவுட் தொடங்கும் முன் அல்லது அதற்குப் பிறகு பாலிசியை சரணடைவது போன்ற முன்கூட்டிய சரணடைதல், விளக்கப்பட்ட முதிர்வு மதிப்பை விட கணிசமாகக் குறைவான பேஅவுட்டுக்கு வழிவகுக்கும் என்பதை நினைவில் கொள்ளவும்" கூடுதல் விவரங்களுக்கு தயவுசெய்து நன்மை விளக்கப்படத்தைப் பார்க்கவும்". லாக்-இன் காலத்தை பொருந்தக்கூடியதாக புரிந்துகொள்வது மற்றும் பணம் செலுத்துதல் தொடங்குவதற்கு முன்னும் பின்னும் செலுத்த வேண்டிய சரண்டர் மதிப்பு. முதன்மை பாலிசிக்கான பிரீமியங்களைச் செலுத்தாத பட்சத்தில், ரைடர் நன்மையும் நிறுத்தப்படும்.',
      },
      {
        type: "text",
        content:
          "நிலுவையில் உள்ள தேவைகள் பூர்த்தி செய்யப்பட்டால் கொள்கை மாற்றத்திற்கு நாங்கள் இப்போது தொடர்வோம். பாலிசியின் விதிமுறைகளில் நீங்கள் திருப்தி அடையவில்லையென்றாலோ அல்லது ஏதேனும் மாற்றம் தேவைப்பட்டாலோ, இலவசப் பார்வைக் காலத்திற்குள் எங்களைத் தொடர்புகொள்வதற்கான விருப்பம் உங்களுக்கு உள்ளது, உங்கள் பாலிசியில் உள்ள ஃப்ரீலுக் காலம் உங்களின் இயற்பியல் கொள்கை ஆவணம் கிடைத்த 30 நாட்களில் இருந்து 15 நாட்கள் ஆகும். உங்கள் பாலிசியை இ-இன்சூரன்ஸ் கணக்கில் வரவு வைக்கும் தேதி.",
      },
      {
        type: "checkbox",
        content:
          "இந்த பாலிசிக்கு விண்ணப்பிக்கும் போது, ​​கடந்த காலத்தில் நான் பெற்ற அனைத்து பாலிசி விவரங்களையும் விண்ணப்பப் படிவத்தில் அறிவித்துள்ளேன் என்பதை உறுதி செய்கிறேன்.",
      },
    ],
    common_points_end: [
      {
        type: "text",
        content:
          "பாலிசி கால மற்றும் பிரீமியம் செலுத்தும் காலம் முடிவதற்குள் பாலிசியை ஒப்படைப்பது, விளக்கப்பட்ட முதிர்வு மதிப்பை விட கணிசமாக குறைவான ஊதியத்திற்கு வழிவகுக்கும் என்பதை நினைவில் கொள்ளவும். கூடுதல் விவரங்களுக்கு, நன்மை விளக்கப்படத்தைப் பார்க்கவும். முதன்மை பாலிசிக்கான பிரீமியங்களைச் செலுத்தாத பட்சத்தில், ரைடர் நன்மையும் நிறுத்தப்படும்.",
      },
      {
        type: "text",
        content:
          "நிலுவையில் உள்ள தேவைகள் பூர்த்தி செய்யப்பட்டால் கொள்கை மாற்றத்திற்கு நாங்கள் இப்போது தொடர்வோம். பாலிசியின் விதிமுறைகளில் நீங்கள் திருப்தி அடையவில்லையென்றாலோ அல்லது ஏதேனும் மாற்றம் தேவைப்பட்டாலோ, இலவசப் பார்வைக் காலத்திற்குள் எங்களைத் தொடர்புகொள்வதற்கான விருப்பம் உங்களுக்கு உள்ளது, உங்கள் பாலிசியின் ஃப்ரீலுக் காலம் உங்களின் இயற்பியல் கொள்கை ஆவணம் கிடைத்த 30 நாட்களில் இருந்து 15 நாட்கள் ஆகும். உங்கள் பாலிசியை இ-இன்சூரன்ஸ் கணக்கில் வரவு வைக்கும் தேதி.",
      },
    ],
  },
  landing_page: {
    start: "தொடங்கு",
    hi: "வணக்கம்",
    heading_1a:
      "ஆதித்யா பிர்லா சன் லைஃப் இன்சூரன்ஸ் குடும்பத்திற்கு வரவேற்கிறோம் ",
    heading_1b: "உங்கள் விண்ணப்ப எண்",
  },
  personal_detail_page: {
    personal_title: "சொந்த விவரங்கள்",
    application_number: "விண்ணப்ப எண்",
    policy_number: "கொள்கை உரிமையாளர்",
    owner_DOB: "உரிமையாளர் பிறந்த தேதி",
    life_insured: "ஆயுள் காப்பீடு",
    insured_DOB: "காப்பீடு செய்யப்பட்ட பிறந்த தேதி",
    nominee_name: "நாமினி பெயர்",
    income: "உரிமையாளர் வருமானம்",
    occupation: "உரிமையாளர் தொழில்",
    email: "மின்னஞ்சல் முகவரி",
    contact_number: "தொடர்பு எண்",
    address: "முகவரி",
    city_state: "நகரம்/மாநிலம்",
    pinCode: "அஞ்சல் குறியீடு",
    hdfcCheckBox:
      "எனது காப்பீட்டுத் திட்டத்தை விரைவாகச் செயல்படுத்துவதற்கு வசதியாக, தொலைபேசி எண், மின்னஞ்சல் ஐடி, முகவரி, பணமில்லா கடன், சுயவிவரம் போன்ற எனது தனிப்பட்ட தகவல்களைக் காப்பீட்டு நிறுவனத்துடன் பகிர்ந்து கொள்ள நான் HDFC வங்கிக்கு இதன்மூலம் ஒப்புதல் அளிக்கிறேன். இந்தக் காப்பீட்டை வாங்கும் போது, ​​வேறு எந்த வங்கிப் பொருள்/சேவைக்கும் விற்பனைப் பிரதிநிதியால் எந்த வாக்குறுதியும் அளிக்கப்படவில்லை என்பதை இதன் மூலம் உறுதி செய்கிறேன்.",
    info: 'திரையில் காட்டப்படும் அனைத்து தகவல்களும் சரியாக இருந்தால், "ஏற்கிறேன்" என்பதைக் கிளிக் செய்யவும், இல்லையெனில் "ஏற்கவில்லை" என்பதைக் கிளிக் செய்யவும்.',
  },
  photo_proof_page: {
    confirmation: "உறுதிப்படுத்தல்",
    subTitle_1a: "என்பதை உறுதிப்படுத்துகிறீர்கள் ",
    subTitle_1b: "முந்தைய பக்கத்தில் கொடுக்கப்பட்ட விவரங்கள் சரியானவை.",
    subTitle_2: "புகைப்படத்தைப் பிடிக்க, பிடிப்பு பொத்தானைக் கிளிக் செய்யவும்.",
    personal: "தனிப்பட்ட",
    policy: "கொள்கை",
  },
  policy_detail_page: {
    policy_title: "கொள்கை விவரங்கள்",
    plan_name: "திட்டத்தின் பெயர்",
    payment: "கட்டண தவணைக்கூறு",
    policy_term: "கொள்கை காலம்",
    years: " ஆண்டுகள்",
    premium_payment: "பிரீமியம் செலுத்தும் காலம்",
    premium_amount: "பிரீமியம் தொகை",
    sum_assured: "காப்பீட்டுத் தொகை",
    purpose_of_insurance: "காப்பீட்டின் நோக்கம்",
    application_no: "விண்ணப்ப எண்",
    plan_type: "திட்ட வகை",
    info: 'திரையில் காட்டப்படும் அனைத்து தகவல்களும் சரியாக இருந்தால், "ஏற்கிறேன்" என்பதைக் கிளிக் செய்யவும், இல்லையெனில் "ஏற்கவில்லை" என்பதைக் கிளிக் செய்யவும்.',
  },
  thank_you_page: {
    thank_you_title: "நன்றி",
    message1:
      "உங்கள் மதிப்புமிக்க நேரத்திற்கு, உங்கள் விற்பனைப் பிரதிநிதி விரைவில் உங்களைத் தொடர்புகொள்வார்",
    message2:
      "உங்கள் மதிப்புமிக்க நேரத்திற்கு. உங்கள் விருப்பமான ஆயுள் காப்பீட்டாளராக ஆதித்யா பிர்லா சன் லைஃப் இன்சூரன்ஸைத் தேர்ந்தெடுத்ததற்காக உங்கள் முடிவைப் பாராட்டுகிறோம்.",
    message3: "உங்கள் விண்ணப்ப எண் ",
  },
  verification_page: {
    verification_title: "சரிபார்ப்பு",
    verification_sub_title: "கீழே உள்ள விவரங்களை உள்ளிடவும்",
    verify_dob: "ஆயுள் காப்பீடு செய்யப்பட்டவரின் பிறந்த தேதி",
    verify_phone: "முன்மொழிபவரின் தொலைபேசி எண்",
    language: "மொழி",
    otp_title: "உங்கள் எண்ணுக்கு அனுப்பப்பட்ட OTP ஐ உள்ளிடவும்",
    otp_placeHolder: "OTP",
    seconds_left: "மீதமுள்ள வினாடிகள்..",
    errorMsg1:
      "நீங்கள் எல்லா முயற்சிகளையும் தாண்டிவிட்டீர்கள். தயவுசெய்து மீண்டும் அழைக்கவும் ",
    errorMsg2: "ஏதோ தவறாகிவிட்டது, மீண்டும் முயற்சிக்கவும்.",
    errorMsg12: " மற்றும் சரியான விவரங்களை உள்ளிடவும்.",
    incorrectMsg: "தவறான OTP. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    sendOtpAgain: "OTP மீண்டும் அனுப்பப்பட்டுள்ளது.",
    wrongDate:
      "உள்ளிடப்பட்ட பிறந்த தேதி தவறானது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    wrongPhone: "உள்ளிட்ட ஃபோன் தவறானது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    wrongLanguage:
      "தேர்ந்தெடுக்கப்பட்ட மொழி தவறானது. தயவு செய்து மீண்டும் முயற்சிக்கவும்.",
    otp_disclaimer: "பதிவு செய்யப்பட்ட மொபைல் எண்ணுக்கு OTP அனுப்பப்படும்",
  },
  video_proof_page: {
    video_title: "Video Undertaking",
    detail_1: "பதிவு பொத்தானைக் கிளிக் செய்து கீழே உள்ள உரையைப் படிக்கவும்",
    detail_2_a: "I ",
    detail_2_b:
      ", என்ற விவரங்களை நான் புரிந்து கொண்டேன் என்பதை இதன் மூலம் உறுதி செய்யவும்",
    detail_3:
      " மற்றும் எனக்கு விளக்கப்பட்ட விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்கிறேன். எனது விண்ணப்பத்தை செயலாக்க நான் ஒப்புக்கொள்கிறேன். எனது மொபைல் எண்",
    recordFailure:
      "மன்னிக்கவும், வீடியோ வெற்றிகரமாக பதிவேற்றப்படவில்லை. மீண்டும் பதிவேற்ற சமர்ப்பி பொத்தானைக் கிளிக் செய்யவும்.",
    permissionMsg:
      "வீடியோ அனுமதி மறுக்கப்பட்டது, வீடியோவிற்கு அனுமதி வழங்கவும்",
    record_again: "மீண்டும் பதிவு செய்யவும்",
  },
  photo_dialog_page: { confirm_title: "எடுக்கப்பட்ட படத்தை உறுதிப்படுத்தவும்" },
  buttons: {
    initiate_recorder: "ரெக்கார்டரைத் தொடங்கவும்",
    retake: "மீண்டும் எடுக்கவும்",
    confirm: "உறுதிப்படுத்தவும்",
    stop: "நிறுத்து",
    next: "அடுத்தது",
    back: "திரும்பி செல்",
    submit: "சமர்ப்பிக்கவும்",
    resend: "மீண்டும் அனுப்பு",
    agree: "ஒப்புக்கொள்கிறேன்",
    disagree: "உடன்படவில்லை",
    capture: "பிடிக்கவும்",
    record: "பதிவு செய்",
    re_record: "மறு பதிவு செய் ",
    verify: "சரிபார்க்க",
  },
};
